import styled from "styled-components";

export const CssCampanhasTabs = styled.div`
        width: 100%;
        margin-top: 75px;
        background: #fbf2dc;
        font-family: "Barlow", sans-serif;

        .campanhasTabs {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 14px;
                width: min(760px, 92%);
                margin: 0 auto;
                padding: 22px 0;
        }

        .campanhasTab {
                appearance: none;
                position: relative;
                isolation: isolate;
                min-width: 160px;
                border: 0;
                background: #d52b1e;
                color: #d52b1e;
                cursor: pointer;
                font-size: 16px;
                font-weight: 700;
                line-height: 1;
                letter-spacing: 0;
                padding: 13px 30px;
                clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
                transition: color 0.25s ease, background 0.25s ease, transform 0.25s ease;
        }

        .campanhasTab::before {
                content: "";
                position: absolute;
                inset: 1px;
                z-index: -1;
                background: #fbf2dc;
                clip-path: polygon(9px 0, 100% 0, calc(100% - 9px) 100%, 0 100%);
                transition: background 0.25s ease;
        }

        .campanhasTab span {
                position: relative;
                z-index: 1;
        }

        .campanhasTab:hover,
        .campanhasTab:focus-visible {
                outline: none;
                transform: translateY(-2px);
        }

        .campanhasTab:hover::before,
        .campanhasTab:focus-visible::before {
                background: #fff7e7;
        }

        .campanhasTabAtiva {
                color: #fbf2dc;
        }

        .campanhasTabAtiva::before {
                background: #d52b1e;
        }

        .campanhasTabAtiva:hover::before,
        .campanhasTabAtiva:focus-visible::before {
                background: #d52b1e;
        }

        @media (max-width: 768px) {
                margin-top: 70px;

                .campanhasTabs {
                        gap: 10px;
                        padding: 16px 0;
                }

                .campanhasTab {
                        min-width: 130px;
                        font-size: 16px;
                        padding: 12px 22px;
                }
        }

        @media (max-width: 420px) {
                .campanhasTabs {
                        width: 94%;
                }

                .campanhasTab {
                        min-width: 0;
                        flex: 1;
                        padding: 12px 14px;
                }
        }
`;

export const CssHome = styled.div`
	width: 100%;
	background: #ce2e1e;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.campanhasSuvinilHero {
		width: 100%;
		margin-top: 0;
		background: #ce2e1e;
		position: relative;
		overflow: hidden;
	}

		.campanhasSuvinilLogoWrap {
		width: 100%;
		min-height: 105px;
		/* display: flex;
		align-items: center;
		justify-content: center; */
		padding: 28px 24px 24px;
		box-sizing: border-box;
		text-align: center;

                h1 {
					font-size: 35px;
					color: #fff;
					display: block;
					font-weight: 300;
                }
	}

	.campanhasSuvinilTitulo {
		opacity: 0;
		transform: translateY(70px);
		transition: opacity 0.85s ease 0.9s, transform 0.85s ease 0.9s;

		strong{
			font-size:
		}
	}

        .campanhasSuvinilLogo {
                width: auto;
                max-width: 90%;
                height: 45px;
                object-fit: contain;
		align-items: center;
		display: inline-block;
		opacity: 0;
		transform: translateY(-120px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animateSuvinilHome .campanhasSuvinilLogo {
		opacity: 1;
		transform: translateY(0);
	}

	.animateSuvinilHome .campanhasSuvinilTitulo {
		opacity: 1;
		transform: translateY(0);
	}

	.campanhasSuvinilCapaWrap {
		width: 100%;
		background: #111;
		position: relative;
		overflow: hidden;

		iframe{
			width:100%;
			height:1080px
		}
	}

	.campanhasSuvinilCapa {
		width: 100%;
		height: auto;
		display: block;
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.8s ease 0.22s, transform 0.8s ease 0.22s;
	}

	.animateSuvinilHome .campanhasSuvinilCapa {
		opacity: 1;
		transform: translateY(0);
	}


	@media (max-width: 1680px) {
		
	.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:920px
			}
		}

	}


	@media (max-width: 1440px) {
		
		.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:800px
			}
		}

	}

	@media (max-width: 1366px) {
		.campanhasSuvinilLogoWrap {
			padding: 24px 20px 20px;
		}

                .campanhasSuvinilLogo {
                        width: auto;
                        max-width: 90%;
                        height: 45px;
                }

		.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:750px
			}
		}


	}

	@media (max-width: 1024px) {

		.campanhasSuvinilCapaWrap {

			iframe{
				width:100%;
				height:580px
			}
		}

	}

	@media (max-width: 1100px) {

                .campanhasSuvinilLogo {
                        width: auto;
                        max-width: 90%;
                        height: 45px;
                }
	}

	@media (max-width: 820px) {
		
		.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:480px
			}
		}

	}

	@media (max-width: 768px) {

		.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:430px
			}
		}

		.campanhasSuvinilHero {
			margin-top: 0;
		}

		.campanhasSuvinilLogoWrap {
			min-height: 120px;
			padding: 22px 18px 18px;
		}

                .campanhasSuvinilLogo {
                        width: auto;
                        max-width: 90%;
                        height: 45px;
                        transform: translateY(-80px);
                }

                .campanhasSuvinilTitulo {
                        font-size: 35px;
                        transform: translateY(55px);
                }

		.campanhasSuvinilCapa {			
			transform: translateY(60px);
		}
	}

	@media (max-width: 520px) {

                .campanhasSuvinilLogoWrap{
                        h1{
                                font-size: 20px;
                        }
                }

		.campanhasSuvinilCapaWrap {			

			iframe{
				width:100%;
				height:300px
			}
		}

		.campanhasSuvinilLogoWrap {
			min-height: 95px;
			padding: 10px;
		}

                .campanhasSuvinilLogo {
                        width: auto;
                        max-width: 90%;
                        height: 30px;
                }

                .campanhasSuvinilTitulo {
                        font-size: 20px;
                        line-height: 1.12;
                }

		.campanhasSuvinilCapa {			
			transform: translateY(48px);
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.campanhasSuvinilLogo,
		.campanhasSuvinilTitulo,
		.campanhasSuvinilCapa {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssSuvinilCase = styled.div`
	width: 100%;
	background: #ce2e1e;
	font-family: "Barlow", sans-serif;
	 /* overflow: hidden;  */

	.suvinilCaseSection {
		width: 100%;
		background: #ce2e1e;
		position: relative;
		 overflow: hidden; 
	}

	.suvinilCaseContainer {
		width: 100%;
		max-width: 1440px;
		height: 1030px;
		margin: 0 auto;
		position: relative;
		/* overflow: hidden; */
		box-sizing: border-box;
	}

	.suvinilCaseLogo {
		width: 285px;
		height: auto;
		display: block;
		position: absolute;
		left: 8.5%;
		top: 95px;
		z-index: 8;
	}

	.suvinilCaseTexto {
		position: absolute;
		z-index: 8;
		color: #7fefff;
		font-size: 34px;
		line-height: 1.18;
		font-weight: 400;
		letter-spacing: 0;
	}

	.suvinilCaseTexto p {
		margin: 0;
	}

	.suvinilCaseTexto1 {
		width: 100%;
		max-width: 520px;
		left: 31.5%;
		top: 100px;
	}

	.suvinilCaseTexto2 {
		width: 100%;
		max-width: 390px;
		left: 8.5%;
		top: 360px;
	}

	.suvinilCaseSeta {
		width: 88px;
		height: auto;
		display: block;
		position: absolute;
		left: 9.4%;
		top: 605px;
		z-index: 8;
	}

	.suvinilCaseNumero {
		display: block;
		position: absolute;
		right: 15.2%;
		top: 175px;
		z-index: 8;
		color: #7fefff;
		font-size: 250px;
		line-height: 0.9;
		font-weight: 700;
		letter-spacing: -0.07em;
	}

	.suvinilCaseRevista {
		width: 960px;
		height: auto;
		display: block;
		position: absolute;
		right:5%;
		bottom: -45px;
		z-index: 7;
		filter: drop-shadow(0 22px 22px rgba(0, 0, 0, 0.22));
	}

	.suvinilCaseCanto {
		width: 255px;
		height: 255px;
		position: absolute;
		left: 0;
		bottom: 0;
		z-index: 5;
		background: #7fefff;
		clip-path: polygon(0 0, 0 100%, 100% 100%);
	}

	.suvinilCaseContorno {
		width: 438px;
		height: 438px;
		position: absolute;
		right:0;
		top: 0;
		z-index: 4;
		pointer-events: none;
		border-top: 3px solid #7fefff;
		border-right: 3px solid #7fefff;
		box-sizing: border-box;
	}

	.suvinilCaseContorno::before {
		content: "";
		width: 620px;
		height: 3px;
		display: block;
		position: absolute;
		left: 0;
		top: -3px;
		background: #7fefff;
		transform: rotate(45deg);
		transform-origin: left top;
	}

	.animSuvinilLogo,
	.animSuvinilTexto1 {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.82s ease, transform 0.82s ease;
	}

	.animSuvinilTexto2 {
		opacity: 0;
		transform: translateX(130px);
		transition: opacity 0.82s ease 0.48s, transform 0.82s ease 0.48s;
	}

	.animSuvinilSeta {
		opacity: 0;
		transform: translateX(-70px);
		transition: opacity 0.72s ease 1.1s, transform 0.72s ease 1.1s;
	}

	.animSuvinilNumero {
		opacity: 0;
		transform: translateX(100px);
		transition: opacity 0.82s ease 1.22s, transform 0.82s ease 1.22s;
	}

	.animSuvinilRevista {
		opacity: 0;
		transform: translateY(125px);
		transition: opacity 0.9s ease 1.8s, transform 0.9s ease 1.8s;
	}

	.animSuvinilCanto {
		opacity: 0;
		transform: translate(-90px, 90px);
		transition: opacity 0.78s ease 2.45s, transform 0.78s ease 2.45s;
	}

	.animSuvinilContorno {
		opacity: 0;
		transform: translateX(180px);
		transition: opacity 0.78s ease 2.45s, transform 0.78s ease 2.45s;
	}

	.animateSuvinilCase .animSuvinilLogo,
	.animateSuvinilCase .animSuvinilTexto1,
	.animateSuvinilCase .animSuvinilTexto2,
	.animateSuvinilCase .animSuvinilSeta,
	.animateSuvinilCase .animSuvinilNumero,
	.animateSuvinilCase .animSuvinilRevista,
	.animateSuvinilCase .animSuvinilCanto,
	.animateSuvinilCase .animSuvinilContorno {
		opacity: 1;
		transform: translate(0, 0);
	}

	@media (max-width: 1366px) {
		.suvinilCaseContainer {
			max-width: 1180px;
			height: 845px;
		}

		.suvinilCaseLogo {
			width: 245px;
			top: 78px;
		}

		.suvinilCaseTexto {
			font-size: 28px;
		}

		.suvinilCaseTexto1 {
			max-width: 455px;
			top: 84px;
		}

		.suvinilCaseTexto2 {
			max-width: 330px;
			top: 305px;
		}

		.suvinilCaseSeta {
			width: 76px;
			top: 500px;
		}

		.suvinilCaseNumero {
			right: 14.8%;
			top: 145px;
			font-size: 210px;
		}

		.suvinilCaseRevista {
			width: 790px;
			right: 0px;
			bottom: -38px;
		}

		.suvinilCaseCanto {
			width: 210px;
			height: 210px;
		}

		.suvinilCaseContorno {
			width: 365px;
			height: 365px;
		}

		.suvinilCaseContorno::before {
			width: 515px;
		}
	}

	@media (max-width: 1100px) {
		.suvinilCaseContainer {
			width: 100%;
			height: 760px;
		}

		.suvinilCaseLogo {
			left: 6%;
			width: 220px;
		}

		.suvinilCaseTexto {
			font-size: 24px;
		}

		.suvinilCaseTexto1 {
			left: 31%;
			max-width: 410px;
		}

		.suvinilCaseTexto2 {
			left: 6%;
			max-width: 310px;
			top: 285px;
		}

		.suvinilCaseSeta {
			left: 6.8%;
			top: 465px;
		}

		.suvinilCaseNumero {
			right: 9%;
			font-size: 185px;
		}

		.suvinilCaseRevista {
			width: 690px;
			right: 30px;
        	bottom: -85px;
		}
	}

	@media (max-width: 820px) {
		.suvinilCaseContainer {
			height: 760px;
		}

		.suvinilCaseLogo {
			width: 190px;
			left: 24px;
			top: 58px;
		}

		.suvinilCaseTexto {
			font-size: 20px;
			line-height: 1.22;
		}

		.suvinilCaseTexto1 {
			left: 260px;
			top: 60px;
			max-width: 360px;
		}

		.suvinilCaseTexto2 {
			left: 24px;
			top: 245px;
			max-width: 280px;
		}

		.suvinilCaseSeta {
			width: 64px;
			left: 30px;
			top: 420px;
		}

		.suvinilCaseNumero {
			right: 80px;
			top: 205px;
			font-size: 145px;
		}

		.suvinilCaseRevista {
			width: 750px;		
			
		}

		.suvinilCaseCanto {
			width: 165px;
			height: 165px;
		}

		.suvinilCaseContorno {
			width: 255px;
			height: 255px;
		}

		.suvinilCaseContorno::before {
			width: 360px;
			height: 2px;
			top: -2px;
		}
	}

	@media (max-width: 620px) {
		.suvinilCaseContainer {
			height: 725px;
		}

		.suvinilCaseLogo {
			width: 170px;
			left: 20px;
			top: 42px;
		}

		.suvinilCaseTexto {
			font-size: 17px;
		}

		.suvinilCaseTexto1 {
			left: 20px;
			top: 165px;
			max-width: 300px;
		}

		.suvinilCaseTexto2 {
			left: 20px;
			top: 290px;
			max-width: 250px;
		}

		.suvinilCaseSeta {
			width: 58px;
			left: 24px;
			top: 465px;
		}

		.suvinilCaseNumero {
			right: 22px;
			top: 214px;
			font-size: 118px;
		}

		.suvinilCaseRevista {
			width: 560px;			
			bottom: 18px;
		}
	}

	@media (max-width: 420px) {
		.suvinilCaseContainer {
			height: 620px;
		}

		.suvinilCaseLogo {
			width: 150px;
		}

		.suvinilCaseTexto {
			font-size: 15px;
		}

		.suvinilCaseTexto1 {
			top: 145px;
			max-width: 270px;
		}

		.suvinilCaseTexto2 {
			top: 260px;
			max-width: 220px;
		}

		.suvinilCaseSeta {
			width: 50px;
			top: 420px;
			}

		.suvinilCaseNumero {
			top: 205px;
			font-size: 92px;
		}

		.suvinilCaseRevista {
			width: 400px;
			right: 0;
			bottom: -55px;
		}

		.suvinilCaseCanto {
			width: 120px;
			height: 120px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animSuvinilLogo,
		.animSuvinilTexto1,
		.animSuvinilTexto2,
		.animSuvinilSeta,
		.animSuvinilNumero,
		.animSuvinilRevista,
		.animSuvinilCanto,
		.animSuvinilContorno {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssSuvinilOutdoor = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= PARTE 03 - OUTDOOR ========================= */

	.suvinilOutdoorSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
	}

	.suvinilOutdoorContainer {
		width: 100%;
		max-width: 1440px;
		height: 1200px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;

	}

	.suvinilOutdoorNumero {
		display: block;
		position: absolute;
		left: 8%;
		top: -28px;
		z-index: 8;
		color: #e50000;
		font-size: 330px;
		line-height: 0.9;
		font-weight: 700;
		letter-spacing: -0.08em;
	}

	.suvinilOutdoorFaixa {
		width: 360px;
		height: 88px;
		position: absolute;
		left:35%;
		top: 170px;
		z-index: 6;
		background: #e50000;
		clip-path: polygon(0 0, 100% 0, 88% 100%, 0 100%);
	}

	.suvinilOutdoorImg {
		width: 790px;
		height: auto;
		display: block;
		position: absolute;
		left: 8%;
		top: 255px;
		z-index: 7;
	}

	.suvinilOutdoorTextoTopo {
		width: 100%;
		max-width: 390px;
		position: absolute;
		right: 6.5%;
		top: 285px;
		z-index: 10;
		color: #e50000;
		font-size: 58px;
		line-height: 1.08;
		font-weight: 500;
		letter-spacing: -0.03em;
	}

	.suvinilOutdoorTextoTopo p {
		margin: 0;
	}

	.suvinilOutdoorQuadrado {
		width: 104px;
		height: auto;
		display: block;
		margin: 0 0 54px 18px;
	}

	.suvinilOutdoorSeta {
		width: 86px;
		height: auto;
		display: block;
		position: absolute;
		right: 30px;
		top: 120px;
	}

	.suvinilOutdoorElemento {
		width: 360px;
		height: 610px;
		position: absolute;
		left: 2.5%;
		bottom: -128px;
		z-index: 9;
		pointer-events: none;
	}

	.suvinilOutdoorElemento::before,
	.suvinilOutdoorElemento::after {
		content: "";
		display: block;
		position: absolute;
		background: #e50000;
	}

	.suvinilOutdoorElemento::before {
		width: 5px;
		height: 430px;
		right: 0;
		top: 145px;
	}

	.suvinilOutdoorElemento::after {
		width: 515px;
		height: 5px;
		right: 0;
		top: 145px;
		transform: rotate(-48deg);
		transform-origin: right center;
	}

	.suvinilOutdoorVazado {
		display: none;
	}

	.suvinilOutdoorTextoBaixo {
		width: 100%;
		max-width: 360px;
		position: absolute;
		right: 9%;
		top: 670px;
		z-index: 10;
		color: #111;
		font-size: 35px;
		line-height: 1.22;
		font-weight: 500;
		letter-spacing: -0.02em;
	}

	.suvinilOutdoorTextoBaixo p {
		margin: 0;
	}

	.suvinilOutdoorLorem {
		width: 100%;
		position: absolute;
		left: 7%;
		bottom: 92px;
		z-index: 12;
		font-size: 195px;
		line-height: 0.78;
		font-weight: 800;
		/* letter-spacing: -0.08em; */
		color: #fff7df;
		white-space: nowrap;
	}

	.suvinilOutdoorLorem p {
		margin: 0;
		letter-spacing: -6px;
	}

	.suvinilOutdoorLorem strong {
		color: #e50000;
		font-weight: 800;
	}

	.animOutdoorNumero {
		opacity: 0;
		transform: translateX(-140px);
		transition: opacity 0.8s ease, transform 0.8s ease;
	}

	.animOutdoorImg {
		opacity: 0;
		transform: translateY(-130px);
		transition: opacity 0.9s ease 0.45s, transform 0.9s ease 0.45s;
	}

	.animOutdoorTextoTopo {
		opacity: 0;
		transform: translateX(120px);
		transition: opacity 0.82s ease 1.05s, transform 0.82s ease 1.05s;
	}

	.animOutdoorFaixa {
		opacity: 0;
		transform: translateX(-110px);
		transition: opacity 0.82s ease 1.7s, transform 0.82s ease 1.7s;
	}

	.animOutdoorElemento {
		opacity: 0;
		transform: translateY(120px);
		transition: opacity 0.78s ease 1.75s, transform 0.78s ease 1.75s;
	}

	.animOutdoorVazado {
		opacity: 0;
		transform: translateX(-120px) rotate(-48deg);
		transition: opacity 0.78s ease 2.35s, transform 0.78s ease 2.35s;
	}

	.animOutdoorTextoBaixo {
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.82s ease 2.85s, transform 0.82s ease 2.85s;
	}

	.animOutdoorLorem {
		opacity: 0;
		transform: translateY(95px);
		transition: opacity 0.85s ease 3.25s, transform 0.85s ease 3.25s;
	}

	.animateSuvinilOutdoor .animOutdoorNumero,
	.animateSuvinilOutdoor .animOutdoorImg,
	.animateSuvinilOutdoor .animOutdoorTextoTopo,
	.animateSuvinilOutdoor .animOutdoorFaixa,
	.animateSuvinilOutdoor .animOutdoorVazado,
	.animateSuvinilOutdoor .animOutdoorTextoBaixo,
	.animateSuvinilOutdoor .animOutdoorLorem {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateSuvinilOutdoor .animOutdoorVazado {
		opacity: 1;
		transform: translate(0, 0) rotate(-48deg);
	}

	.animateSuvinilOutdoor .animOutdoorElemento {
		opacity: 1;
		transform: translate(0, 0);
	}

	@media (max-width: 1366px) {
		.suvinilOutdoorContainer {
			max-width: 1180px;
			height: 885px;
		}

		.suvinilOutdoorNumero {
			font-size: 275px;
			top: -20px;
		}

		.suvinilOutdoorFaixa {
			width: 375px;
			height: 74px;
			top: 142px;
		}

		.suvinilOutdoorImg {
			width: 650px;
			top: 215px;
		}

		.suvinilOutdoorTextoTopo {
			max-width: 330px;
			right: 8%;
			top: 235px;
			font-size: 48px;
		}

		.suvinilOutdoorQuadrado {
			width: 86px;
			margin-bottom: 44px;
		}

		.suvinilOutdoorSeta {
			width: 72px;
			top: 98px;
		}

		.suvinilOutdoorElemento {
			width: 305px;
			height: 500px;
			left: 2.5%;
			bottom: -112px;
		}

		.suvinilOutdoorElemento::before {
			width: 4px;
			height: 350px;
			top: 122px;
		}

		.suvinilOutdoorElemento::after {
			width: 420px;
			height: 4px;
			top: 122px;
		}

		.suvinilOutdoorTextoBaixo {
			max-width: 310px;
			top: 585px;
			font-size: 29px;
		}

		.suvinilOutdoorLorem {
			font-size: 128px;
			bottom: -14px;
		}
	}

	@media (max-width: 1100px) {
		.suvinilOutdoorContainer {
			height: 875px;
		}

		.suvinilOutdoorNumero {
			left: 6%;
			font-size: 230px;
		}

		.suvinilOutdoorFaixa {
			left: 26%;
			width: 330px;
		}

		.suvinilOutdoorImg {
			left: 6%;
			width: 570px;
		}

		.suvinilOutdoorTextoTopo {
			max-width: 285px;
			right: 5%;
			font-size: 40px;
		}

		.suvinilOutdoorTextoBaixo {
                        right: 6%;
			max-width: 270px;
			font-size: 25px;
			top: 548px;
		}

		.suvinilOutdoorLorem {
			font-size: 112px;
			left: 10%;
			bottom: 40px;
		}
	}

	@media (max-width: 820px) {
		.suvinilOutdoorContainer {
			height: 785px;
		}

		.suvinilOutdoorNumero {
			left: 22px;
			top: 4px;
			font-size: 150px;
		}

		.suvinilOutdoorFaixa {
			left: 190px;
			top: 125px;
			width: 255px;
			height: 55px;
		}

		.suvinilOutdoorImg {
			left: 22px;
			top: 175px;
			width: 485px
		}

		.suvinilOutdoorTextoTopo {
			max-width:265px;
			right: 1%;
			font-size: 35px;
		}

		.suvinilOutdoorQuadrado {
			width: 62px;
			margin: 0 0 22px 0;
		}

		.suvinilOutdoorSeta {
			width: 62px;
			left: 145px;
			right: auto;
			top: 18px;
		}

		.suvinilOutdoorTextoBaixo {
			right: 10px;
			font-size: 22px;
			top: 490px;
		}

		.suvinilOutdoorElemento {
			left: 0;
			bottom: -34px;
			width: 230px;
			height: 360px;
		}

		.suvinilOutdoorElemento::before {
			height: 240px;
			top: 90px;
		}

		.suvinilOutdoorElemento::after {
			width: 305px;
			top: 90px;
		}

		.suvinilOutdoorLorem {
			left: 24px;
			bottom: 80px;
			font-size: 72px;
		}
	}

	@media (max-width: 620px) {
		.suvinilOutdoorContainer {
			height: 900px;
		}

		.suvinilOutdoorNumero {
			left: 14px;
			top: -8px;
			font-size: 104px;
		}

		.suvinilOutdoorFaixa {
			left: 132px;
			top: 58px;
			width: 178px;
			height: 48px;
		}

		.suvinilOutdoorImg {
			left: 0;
			top: 128px;
			width: 100%;
			max-width: none;
		}

		.suvinilOutdoorTextoTopo {
			left: 24px;
			right: auto;
			top: 560px;
			width: calc(100% - 48px);
			max-width: none;
			font-size: 24px;
			line-height: 1.05;
		}

		.suvinilOutdoorTextoBaixo {
			top: 682px;
			left: 24px;
			right: auto;
			max-width: 320px;
			font-size: 16px;
			line-height: 1.28;
		}

		.suvinilOutdoorElemento {
			display: none;
		}

		.suvinilOutdoorLorem {
			left: 24px;
			bottom: 42px;
			font-size: 50px;
			z-index: 6;
		}

		.suvinilOutdoorQuadrado {
			width: 46px;
			margin: 0 0 10px;
		}

		.suvinilOutdoorSeta {
			width: 46px;
			left: 96px;
			top: 7px;
		}
	}

	@media (max-width: 430px) {
		.suvinilOutdoorContainer {
			height: 855px;
		}

		.suvinilOutdoorNumero {
			font-size: 96px;
			        top: 21px;
		}

		.suvinilOutdoorFaixa {
			left: 122px;
			top: 80px;
			width: 170px;
			height: 45px;
		}

		.suvinilOutdoorImg {
			top: 120px;
		}

		.suvinilOutdoorTextoTopo {
			top: 610px;
			font-size: 22px;
		}

		.suvinilOutdoorTextoBaixo {
			top: 720px;	
			font-size: 17px;	
		}

		.suvinilOutdoorLorem {
			bottom: 34px;
			font-size: 46px;
			display: none
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animOutdoorNumero,
		.animOutdoorImg,
		.animOutdoorTextoTopo,
		.animOutdoorFaixa,
		.animOutdoorElemento,
		.animOutdoorVazado,
		.animOutdoorTextoBaixo,
		.animOutdoorLorem {
			opacity: 1;
			transform: none;
			transition: none;
		}

		.animOutdoorElemento,
		.animOutdoorVazado {
			transform: none;
		}
	}
`;

export const CssSuvinilCards = styled.div`
	width: 100%;
	background: #68d3dc;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.suvinilCardsSection {
		width: 100%;
		position: relative;
		overflow: hidden;
		background: #68d3dc;
	}

	.suvinilCardsFundo {
		width: 100%;
		height: auto;
		display: block;
		position: relative;
		z-index: 1;
	}

	.suvinilCardsContent {
		width: 100%;
		max-width: 1440px;
		height: 100%;
		position: absolute;
		left: 50%;
		top: 0;
		z-index: 3;
		transform: translateX(-50%);
		pointer-events: none;
	}

	.suvinilCardsNumero {
		display: block;
		position: absolute;
		left: 52%;
		top: 31%;
		z-index: 5;
		color: rgba(186, 246, 255, 0.48);
		font-size: 255px;
		line-height: 0.9;
		font-weight: 700;
		letter-spacing: -0.08em;
	}

	.suvinilCardsTexto {
		width: 100%;
		max-width: 520px;
		position: absolute;
		left: 50%;
		top: 49%;
		z-index: 6;
		color: #e50000;
		font-size:70px;
		line-height: 1.1;
		font-weight: 500;
		letter-spacing: -0.08em;
		text-align: center;
	}

	.suvinilCardsTexto p,
	.suvinilCardsDescricao p {
		margin: 0;
	}

	.suvinilCardsDescricao {
		width: 100%;
		max-width: 385px;
		position: absolute;
		left: 61.5%;
		top: 63%;
		z-index: 6;
		color: #111;
		font-size: 34px;
		line-height: 1.22;
		font-weight: 600;
		letter-spacing: -0.02em;
	}

	.suvinilCardsTriangulo {
		position: absolute;
		z-index: 7;
		pointer-events: none;
	}

	.suvinilCardsTrianguloLeft {
		width: 450px;
		height: auto;
		left: -15%;
		bottom: 5%;
		display: block;
	}

	.suvinilCardsTrianguloTop {
		width:450px;
		height: auto;
		right: -400px;
		top:-15px;
		display: block;
		transform: rotate(90deg);
		transform-origin: center;
	}

	.suvinilCardsTrianguloTopMenor {
		width:150px;
		height: auto;
		right: -60px;
		top:14%;
		display: block;
		transform: rotate(90deg);
		transform-origin: center;
	}

	.animCardsNumero {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animCardsTexto {
		opacity: 0;
		transform: translateY(90px);
		transition: opacity 0.85s ease 0.55s, transform 0.85s ease 0.55s;
	}

	.animCardsTrianguloLeft {
		opacity: 0;
		transform: translateX(-160px);
		transition: opacity 0.8s ease 1.15s, transform 0.8s ease 1.15s;
	}

	.animCardsTrianguloTop {
		opacity: 0;
		transform: translateY(-160px) rotate(360deg);
		transition: opacity 0.8s ease 1.55s, transform 0.8s ease 1.55s;
	}

	.animateSuvinilCards .animCardsNumero,
	.animateSuvinilCards .animCardsTexto {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateSuvinilCards .animCardsTrianguloLeft {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateSuvinilCards .animCardsTrianguloTop {
		opacity: 1;
		transform: translate(0, 0) rotate(360deg);
	}

	@media (max-width: 1366px) {
		.suvinilCardsContent {
			max-width: 1180px;
		}

		.suvinilCardsNumero {
			font-size: 210px;
		}

		.suvinilCardsTexto {
			max-width: 460px;
			font-size: 40px;
			top: 52%;
			left: 47%;
		}

		.suvinilCardsDescricao {
			max-width: 360px;
			top: 68%;
			font-size: 29px;
		}

		.suvinilCardsTrianguloLeft {
			width: 430px;
		}


	}

	@media (max-width: 820px) {
		.suvinilCardsFundo {
			width: 150%;
			max-width: none;
			margin-left: -25%;
		}

		.suvinilCardsNumero {
			left: 43%;
			top: 28%;
			font-size: 150px;
		}

		.suvinilCardsTexto {
			left: 46%;
			top: 46%;
			max-width: 410px;
			font-size: 44px;
		}

		.suvinilCardsDescricao {
			left: 60%;
			top: 65.5%;
			max-width: 330px;
			font-size: 25px;
		}

		.suvinilCardsTrianguloLeft {
			width: 350px;
			left: -17%;
		}

		
	}

	@media (max-width: 520px) {
		.suvinilCardsFundo {
			width: 190%;
			margin-left: -75%;
		}

		.suvinilCardsNumero {
			left: 38%;
			top: 27%;
			font-size: 100px;
		}

		.suvinilCardsTexto {
			left: 25%;
			top: 48.5%;
			max-width: 60%;
			font-size: 28px;
			text-align: left;
		}

		.suvinilCardsDescricao {
			left: 35%;
			top:65%;
			max-width: 230px;
			font-size: 21px;
		}

		.suvinilCardsTrianguloLeft {
			width: 270px;
			left: -48%;
			bottom: -15%;
		}

		.suvinilCardsTrianguloTop {
			width: 95px;
			right: -48px;
			display: none
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animCardsNumero,
		.animCardsTexto,
		.animCardsTrianguloLeft,
		.animCardsTrianguloTop {
			opacity: 1;
			transition: none;
		}

		.animCardsNumero,
		.animCardsTexto {
			transform: none;
		}

		.animCardsTrianguloLeft {
			transform: none;
		}

		.animCardsTrianguloTop {
			transform: rotate(90deg);
		}
	}
`;

export const CssSuvinilMetricas = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.suvinilMetricasSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
	}

	.suvinilMetricasContainer {
		width: 100%;
		max-width: 1440px;
		/* height: 770px; */
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.suvinilMetricasVideoWrap {
		width: min(1180px, calc(100% - 96px));
		aspect-ratio: 16 / 9;
		position: absolute;
		left: 50%;
		top: 50%;
		z-index: 10;
		transform: translate(-50%, -50%);
		background: #000;
		overflow: hidden;
	}

	.suvinilMetricasVideoWrap iframe {
		width: 100%;
		height: 100%;
		display: block;
		border: 0;
	}

	.suvinilMetricasFotoWrap {
		width: 288px;
		height: 415px;
		position: absolute;
		left: 6.8%;
		top: 58px;
		z-index: 5;
		overflow: hidden;
	}

	.suvinilMetricasFoto {
		width: 100%;
		height: 100%;
		display: block;
		object-fit: cover;
		filter: grayscale(1);
	}

	.suvinilMetricasTriangulo {
		width: 150px;
		height: auto;
		display: block;
		position: absolute;
		left: 4.6%;
		top: 395px;
		z-index: 6;
	}

	.suvinilMetricasNumero {
		display: block;
		color: #e50000;
		font-weight: 800;
		line-height: 0.85;
		letter-spacing: -0.08em;
	}

	.suvinilMetricasNumeroTop {
		position: absolute;
		left: 25%;
		top: 117px;
		z-index: 7;
		font-size: 178px;
	}

	.suvinilMetricasSocial {
		position: absolute;
		left: 26.2%;
		top: 325px;
		z-index: 8;
		display: flex;
		align-items: center;
		gap: 18px;
	}

	.suvinilMetricasIcon {
		width: 94px;
		height: 94px;
		display: block;
		object-fit: contain;
	}

	.suvinilMetricasLogo {
		width: 92px;
		height: auto;
		display: block;
		margin-left: 8px;
	}

	.suvinilMetricasViews {
		width: 100%;
		max-width: 390px;
		position: absolute;
		right: 1%;
		top: 185px;
		z-index: 8;
		color: #111;
		font-size: 38px;
		line-height: 1.22;
		font-weight: 500;
		letter-spacing: -0.02em;
	}

	.suvinilMetricasViews strong {
		display: block;
		margin-bottom: 22px;
		color: #e50000;
		font-size: 104px;
		line-height: 0.95;
		font-weight: 800;
		letter-spacing: -0.06em;
		text-transform: uppercase;
	}

	.suvinilMetricasViews p,
	.suvinilMetricasInferior p {
		margin: 0;
	}

	.suvinilMetricasInferior {
		position: absolute;
		z-index: 8;
		color: #111;
		font-size: 36px;
		line-height: 1.22;
		font-weight: 500;
		letter-spacing: -0.02em;
	}

	.suvinilMetricasInferior strong {
		display: block;
		margin-bottom: 38px;
		color: #e50000;
		font-size: 150px;
		line-height: 0.88;
		font-weight: 800;
		letter-spacing: -0.08em;
	}

	.suvinilMetricas55 {
		left: 10%;
		top: 650px;
		max-width: 410px;
	}

	.suvinilMetricas100 {
		right: 12.5%;
		top: 648px;
		max-width: 410px;
	}

	.suvinilMetricasAzul {
		width: 285px;
		height: auto;
		display: block;
		position: absolute;
		right: 1%;
		bottom: 1px;
		z-index: 3;
	}

	.animMetricasFoto {
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.8s ease, transform 0.8s ease;
	}

	.animMetricasTriangulo {
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.75s ease 0.35s, transform 0.75s ease 0.35s;
	}

	.animMetricas200 {
		opacity: 0;
		transform: translateY(-130px);
		transition: opacity 0.85s ease 0.75s, transform 0.85s ease 0.75s;
	}

	.animMetricasIcon {
		opacity: 0;
		transform: translateY(55px) scale(0.96);
		transition-property: opacity, transform;
		transition-duration: 0.62s;
		transition-timing-function: ease;
	}

	.icon1 {
		transition-delay: 1.25s;
	}

	.icon2 {
		transition-delay: 1.42s;
	}

	.icon3 {
		transition-delay: 1.59s;
	}

	.icon4 {
		transition-delay: 1.76s;
	}

	.icon5 {
		transition-delay: 1.93s;
	}

	.animMetricasViews {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.8s ease 2.25s, transform 0.8s ease 2.25s;
	}

	.animMetricas55 {
		opacity: 0;
		transform: translateX(130px);
		transition: opacity 0.85s ease 2.85s, transform 0.85s ease 2.85s;
	}

	.animMetricas100 {
		opacity: 0;
		transform: translateX(130px);
		transition: opacity 0.85s ease 2.85s, transform 0.85s ease 2.85s;
	}

	.animMetricasAzul {
		opacity: 0;
		transform: translate(120px, 120px);
		transition: opacity 0.8s ease 3.25s, transform 0.8s ease 3.25s;
	}

	.animMetricasVideo {
		opacity: 0;
		transform: translate(-50%, -50%) translateY(70px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animateSuvinilMetricas .animMetricasFoto,
	.animateSuvinilMetricas .animMetricasTriangulo,
	.animateSuvinilMetricas .animMetricas200,
	.animateSuvinilMetricas .animMetricasIcon,
	.animateSuvinilMetricas .animMetricasViews,
	.animateSuvinilMetricas .animMetricas55,
	.animateSuvinilMetricas .animMetricas100,
	.animateSuvinilMetricas .animMetricasAzul {
		opacity: 1;
		transform: translate(0, 0) scale(1);
	}

	.animateSuvinilMetricas .animMetricasVideo {
		opacity: 1;
		transform: translate(-50%, -50%);
	}

	@media (max-width: 1366px) {
		.suvinilMetricasContainer {
			max-width: 1180px;			
		}

		.suvinilMetricasFotoWrap {
			width: 250px;
			height: 360px;
			top: 52px;
		}

		.suvinilMetricasTriangulo {
			width: 128px;
			top: 345px;
		}

		.suvinilMetricasNumeroTop {
			left: 25%;
			top: 104px;
			font-size: 148px;
		}

		.suvinilMetricasSocial {
			top: 278px;
			gap: 14px;
		}

		.suvinilMetricasIcon {
			width: 78px;
			height: 78px;
		}

		.suvinilMetricasLogo {
			width: 78px;
			
		}

		.suvinilMetricasViews {
			top: 165px;
			max-width: 340px;
			font-size: 32px;
		}

		.suvinilMetricasViews strong {
			font-size: 86px;
		}

		.suvinilMetricasInferior {
			font-size: 30px;
		}

		.suvinilMetricasInferior strong {
			margin-bottom: 32px;
			font-size: 124px;
		}

		.suvinilMetricas55,
		.suvinilMetricas100 {
			top: 545px;
			max-width: 350px;
		}

		.suvinilMetricasAzul {
			width: 390px;
		}

		.suvinilMetricasVideoWrap {
			width: min(980px, calc(100% - 72px));
		}
	}


	@media (max-width: 1366px) {
		.suvinilMetricasLogo {
			display: none
		}

	}

	@media (max-width: 900px) {
		

		.suvinilMetricasFotoWrap {
			left: 6%;
			width: 210px;
			height: 305px;
		}

		.suvinilMetricasTriangulo {
			left: 4%;
			top: 300px;
			width: 110px;
		}

		.suvinilMetricasNumeroTop {
			left: 31%;
			top: 86px;
			font-size: 112px;
		}

		.suvinilMetricasSocial {
			left: 31%;
			top: 220px;
			gap: 10px;
		}

		.suvinilMetricasIcon {
			width: 58px;
			height: 58px;
		}

		.suvinilMetricasLogo {
			width: 56px;
			margin-left: 4px;
			
		}

		.suvinilMetricasViews {
			right: 5%;
			top: 315px;
			max-width: 330px;
			font-size: 27px;
		}

		.suvinilMetricasViews strong {
			margin-bottom: 14px;
			font-size: 70px;
		}

		.suvinilMetricasInferior {
			font-size: 26px;
		}

		.suvinilMetricasInferior strong {
			font-size: 92px;
			margin-bottom: 22px;
		}

		.suvinilMetricas55 {
			left: 8%;
			top: 505px;
			max-width: 330px;
		}

		.suvinilMetricas100 {
			right: 7%;
			top: 505px;
			max-width: 330px;
		}

		.suvinilMetricasVideoWrap {
			width: calc(100% - 40px);
		}
	}

	@media (max-width: 620px) {

		.suvinilMetricasVideoWrap {
			width: calc(100% - 28px);
		}

		.suvinilMetricasFotoWrap {
			left: 8%;
			top: 40px;
			width: 185px;
			height: 270px;
		}

		.suvinilMetricasTriangulo {
			left: 3%;
			top: 260px;
			width: 95px;
		}

		.suvinilMetricasNumeroTop {
			left: 34%;
			top: 82px;
			font-size: 82px;
		}

		.suvinilMetricasSocial {
			left: 30%;
			top: 190px;
			gap: 7px;
			flex-wrap: wrap;
			max-width: 250px;
		}

		.suvinilMetricasIcon {
			width: 46px;
			height: 46px;
		}

		.suvinilMetricasLogo {
			width: 45px;
		}

		.suvinilMetricasViews {
			left: 10%;
			right: auto;
			top: 350px;
			max-width: 300px;
			font-size: 24px;
		}

		.suvinilMetricasViews strong {
			font-size: 64px;
		}

		.suvinilMetricasInferior {
			font-size: 23px;
		}

		.suvinilMetricasInferior strong {
			font-size: 78px;
			margin-bottom: 18px;
		}

		.suvinilMetricas55 {
			left: 10%;
			top: 540px;
			max-width: 400px;
		}

		.suvinilMetricas100 {
			left: 10%;
			right: auto;
			top: 720px;
			max-width: 290px;
		}

		.suvinilMetricasAzul {
			width: 280px;
			right: -95px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animMetricasFoto,
		.animMetricasTriangulo,
		.animMetricas200,
		.animMetricasIcon,
		.animMetricasViews,
		.animMetricas55,
		.animMetricas100,
		.animMetricasAzul {
			opacity: 1;
			transform: none;
			transition: none;
		}

		.animMetricasVideo {
			opacity: 1;
			transform: translate(-50%, -50%);
			transition: none;
		}
	}
`;

export const CssSuvinilCores = styled.div`
	width: 100%;
	background: #ce2e1e;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.suvinilCoresSection {
		position: relative;
		width: 100%;
		background: #ce2e1e;
		overflow: hidden;
		isolation: isolate;
	}

	.suvinilCoresHero {
		position: relative;
		width: 100%;
		max-width: 1440px;
		min-height: 105px;
		margin: 0 auto;
		background: #ce2e1e;
		overflow: visible;
		z-index: 1;
		padding-top: 25px;
	}

        .suvinilCoresLogo {
                display: block;
                margin: 0 auto;
                padding-top: 35px;
                color: #fff;
                text-align: center;
                font-size: 45px;
                font-weight: 500;
                line-height: 1;
        }

	.suvinilCoresTitulo {
		width: min(860px, 86%);
                margin: 10px auto 0;
                color: #8eefff;
                text-align: center;
                font-size: 35px;
                font-weight: 300;
                line-height: 1.18;
        }

	.suvinilCoresTitulo p {
		margin: 0;
	}

	.suvinilCoresTrianguloTop {
		position: absolute;
		right: -8px;
		bottom: -390%;
		width: 445px;
		max-width: 34vw;
		z-index: 1;
		pointer-events: none;
	}

	.suvinilCoresBannerWrap {
		position: relative;
		width: 100%;
		background: #d52b1e;
		overflow: hidden;
		z-index: 3;
		margin: 20px 0 0 0;

		iframe{
			width:100%;
			height:1080px
		}
	}

	.suvinilCoresBanner {
		position: relative;
		display: block;
		width: 100%;
		height: auto;
		z-index: 3;
	}

	.suvinilCoresBottom {
		position: relative;
		width: 100%;
		max-width: 1440px;
		height: 70px;
		margin: 0 auto;
		background: #d52b1e;
		overflow: visible;
		z-index: 1;
	}

	.suvinilCoresTrianguloBottom {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 450px;
		max-width: 34vw;
		z-index: 1;
		pointer-events: none;
	}

	.animCoresLogo {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.8s ease, transform 0.8s ease;
	}

	.animCoresTitulo {
		opacity: 0;
		transform: translateY(90px);
		transition: opacity 0.85s ease 0.35s, transform 0.85s ease 0.35s;
	}

	.animCoresBanner {
		opacity: 0;
		transform: translateY(70px);
		transition: opacity 0.9s ease 0.85s, transform 0.9s ease 0.85s;
	}

	.animCoresTrianguloTop {
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.8s ease 1.35s, transform 0.8s ease 1.35s;
	}

	.animCoresTrianguloBottom {
		opacity: 0;
		transform: translateY(-80px);
		transition: opacity 0.8s ease 1.35s, transform 0.8s ease 1.35s;
	}

	.animateSuvinilCores .animCoresLogo,
	.animateSuvinilCores .animCoresTitulo,
	.animateSuvinilCores .animCoresBanner,
	.animateSuvinilCores .animCoresTrianguloTop,
	.animateSuvinilCores .animCoresTrianguloBottom {
		opacity: 1;
		transform: translateY(0);
	}


	@media (max-width: 1680px) {
		
		.suvinilCoresBannerWrap {			

			iframe{
				width:100%;
				height:860px
			}
		}

	}

	@media (max-width: 1440px) {
		
		.suvinilCoresBannerWrap {			

			iframe{
				width:100%;
				height:800px
			}
		}

	}


	@media (max-width: 1366px) {

		.suvinilCoresBannerWrap {

			iframe{
				width:100%;
				height:750px
			}
		}

		.suvinilCoresLogo {
			padding-top: 30px;
		}

                .suvinilCoresTitulo {
                        font-size: 35px;
                }

		.suvinilCoresTrianguloTop {
			width: 380px;
			
		}

		.suvinilCoresTrianguloBottom {
			width: 390px;
		}
	}

	@media (max-width: 1024px) {

			.suvinilCoresTrianguloTop {
				width: 350px;
				bottom: -300%;
				right: 15px
			}

			.suvinilCoresBannerWrap {			

				iframe{
					width:100%;
					height:580px
				}
			}


	}



	@media (max-width: 820px) {

		.suvinilCoresBannerWrap {			

			iframe{
				width:100%;
				height:480px
			}
		}

		.suvinilCoresLogo {
			padding-top: 24px;
		}

                .suvinilCoresTitulo {
                        width: 90%;
                        font-size: 35px;
                        line-height: 1.15;
                }

		.suvinilCoresTrianguloTop {
			right: -30px;
			bottom: -210%;
			width: 260px;
			max-width: 46vw;
		}

		.suvinilCoresBanner {
			width: 122%;
			margin-left: -11%;
		}

		.suvinilCoresBottom {
			height: 54px;
		}

		.suvinilCoresTrianguloBottom {
			left: -36px;
			width: 300px;
			max-width: 58vw;
		}
	}

	@media (max-width: 520px) {


		.suvinilCoresBannerWrap {			

			iframe{
				width:100%;
				height:260px
			}
		}

                .suvinilCoresLogo {
                        padding-top: 20px;
                        font-size: 30px;
                }

                .suvinilCoresTitulo {
                        width: 92%;
                        margin-top: 8px;
                        font-size: 20px;
                        line-height: 1.16;
                }

		.suvinilCoresTrianguloTop {
			right: -15px;
			bottom: -160%;
			width: 190px;
			max-width: 52vw;
		}

		.suvinilCoresBanner {
			width: 150%;
			margin-left: -25%;
		}

		.suvinilCoresBottom {
			height: 45px;
		}

		.suvinilCoresTrianguloBottom {
			left: -42px;
			width: 235px;
			max-width: 66vw;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animCoresLogo,
		.animCoresTitulo,
		.animCoresBanner,
		.animCoresTrianguloTop,
		.animCoresTrianguloBottom {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssSuvinilCoresDetalhes = styled.div`
	width: 100%;
	background: #80edff;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.suvinilCoresDetalhesSection {
		position: relative;
		width: 100%;
		min-height: 1040px;
		padding: 42px 0 70px;
		background: linear-gradient(to bottom, #d52b1e 0 50%, #68e4ed 50% 100%);
		overflow: hidden;
	}

	.suvinilCoresDetalhesTexto {
		width: min(960px, 82%);
		margin: 0 auto 52px;
		color: #8eefff;
		text-align: center;
		font-size: 32px;
		font-weight: 400;
		line-height: 1.34;
	}

	.suvinilCoresDetalhesTexto p {
		margin: 0;
	}

	.suvinilCoresDetalhesConteudo {
		position: relative;
		width: min(1440px, 100%);
		min-height: 820px;
		margin: 0 auto;
	}

	.suvinilCoresDetalhesVisual {
		position: absolute;
		left: 0;
		top: 120px;
		width: 55%;
		height: 720px;
	}

	.suvinilCoresQuadro {
		position: absolute;
		left: 0;
		top: 35px;
		width: 720px;
		max-width: 76%;
		z-index: 1;
	}

	.suvinilCoresCelular {
		position: absolute;
		left: 43%;
		top: -120px;
		width: 590px;
		max-width:59%;
		z-index: 3;
		filter: drop-shadow(0 18px 26px rgba(0, 0, 0, 0.2));
	}

	.suvinilCoresMetricas {
		position: absolute;
		right: 6%;
		top: 25px;
		width: 35%;
		min-width: 430px;
		z-index: 4;
	}

	.suvinilCoresMetrica {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		font-weight: 800;
	}

	.suvinilCoresMetrica strong {
		display: block;
		font-size: 154px;
		line-height: 0.88;
		font-weight: 900;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	.suvinilCoresMetrica span {
		display: block;
		margin-top: 18px;
		font-size: 42px;
		line-height: 1;
		font-weight: 800;
	}

	.suvinilCoresMetrica10 {
		color: #68e4ed;
		margin-bottom: 160px;
	}

	.suvinilCoresMetrica30 {
		color: #e40b00;
	}

	.suvinilCoresSeta {
		display: block;
		width: 140px;
		margin: 70px auto 0;
	}

	.animCoresDetalhesTexto,
	.animCoresQuadro,
	.animCoresCelular,
	.animCoresMetrica10,
	.animCoresMetrica30,
	.animCoresSeta {
		opacity: 0;
		transition-property: opacity, transform;
		transition-duration: 0.8s;
		transition-timing-function: ease;
	}

	.animCoresDetalhesTexto {
		transform: translateY(-80px);
	}

	.animCoresQuadro {
		transform: translateX(-110px);
		transition-delay: 0.35s;
	}

	.animCoresCelular {
		transform: translateX(120px);
		transition-delay: 0.8s;
	}

	.animCoresMetrica10 {
		transform: translateX(-90px);
		transition-delay: 1.25s;
	}

	.animCoresMetrica30 {
		transform: translateX(-90px);
		transition-delay: 1.65s;
	}

	.animCoresSeta {
		transform: translateY(90px);
		transition-delay: 2.05s;
	}

	.animateSuvinilCoresDetalhes .animCoresDetalhesTexto,
	.animateSuvinilCoresDetalhes .animCoresQuadro,
	.animateSuvinilCoresDetalhes .animCoresCelular,
	.animateSuvinilCoresDetalhes .animCoresMetrica10,
	.animateSuvinilCoresDetalhes .animCoresMetrica30,
	.animateSuvinilCoresDetalhes .animCoresSeta {
		opacity: 1;
		transform: translate(0, 0);
	}

	@media (max-width: 1366px) {
		.suvinilCoresDetalhesSection {
			min-height: 930px;
		}

		.suvinilCoresDetalhesTexto {
			font-size: 29px;
			margin-bottom: 44px;
		}

		.suvinilCoresDetalhesConteudo {
			min-height: 730px;
		}

		.suvinilCoresDetalhesVisual {
			top: 115px;
			height: 650px;
		}

		.suvinilCoresQuadro {
			width: 640px;
		}

		.suvinilCoresCelular {
			width: 520px;
			top: -105px;
		}

		.suvinilCoresMetricas {
			top: 25px;
			right: 5%;
			min-width: 390px;
		}

		.suvinilCoresMetrica strong {
			font-size: 132px;
		}

		.suvinilCoresMetrica span {
			font-size: 36px;
		}

		.suvinilCoresMetrica10 {
			margin-bottom: 145px;
		}
	}

	@media (max-width: 1024px) {
		.suvinilCoresDetalhesSection {
			min-height: 880px;
			background: linear-gradient(to bottom, #d52b1e 0 38%, #68e4ed 38% 100%);
		}

		.suvinilCoresDetalhesTexto {
			width: 86%;
			font-size: 25px;
		}

		.suvinilCoresDetalhesVisual {
			top: 120px;
			width: 68%;
		}

		.suvinilCoresQuadro {
			width: 560px;
			max-width: 84%;
		}

		.suvinilCoresCelular {
			left: 38%;
			width: 450px;
			max-width: 66%;
		}

		.suvinilCoresMetricas {
			right: 2%;
			top: 20px;
			width: 36%;
			min-width: 310px;
		}

		.suvinilCoresMetrica strong {
			font-size: 105px;
		}

		.suvinilCoresMetrica span {
			font-size: 29px;
		}

		.suvinilCoresSeta {
			width: 120px;
		}
	}

	@media (max-width: 760px) {
		.suvinilCoresDetalhesSection {
			min-height: auto;
			padding: 34px 0 54px;
			background: linear-gradient(to bottom, #d52b1e 0 33%, #68e4ed 33% 100%);
		}

		.suvinilCoresDetalhesTexto {
			width: 90%;
			margin-bottom: 28px;
			font-size: 21px;
			line-height: 1.32;
		}

		.suvinilCoresDetalhesConteudo {
			display: flex;
			flex-direction: column;
			width: 100%;
			min-height: 0;
		}

		.suvinilCoresDetalhesVisual {
			position: relative;
			left: auto;
			top: auto;
			width: 100%;
			height: 560px;
			margin-top: 10px;
		}

		.suvinilCoresQuadro {
			left: -10%;
			top: 95px;
			width: 76%;
			max-width: none;
		}

		.suvinilCoresCelular {
			left: 32%;
			top: 0;
			width:60%;
			max-width: none;
		}

		.suvinilCoresMetricas {
			position: relative;
			right: auto;
			top: auto;
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 24px;
			width: 92%;
			min-width: 0;
			margin: 18px auto 0;
		}

		.suvinilCoresMetrica10 {
			color: #e40b00;
			margin-bottom: 0;
		}

		.suvinilCoresMetrica strong {
			font-size: 76px;
		}

		.suvinilCoresMetrica span {
			margin-top: 10px;
			font-size: 22px;
			line-height: 1.05;
		}

		.suvinilCoresSeta {
			grid-column: 1 / -1;
			width: 80px;
			margin: 12px auto 0;
		}
	}

	@media (max-width: 480px) {
		.suvinilCoresDetalhesTexto {
			font-size: 18px;
		}

		.suvinilCoresDetalhesVisual {
			height: 455px;
		}

		.suvinilCoresQuadro {
			left: -22%;
			top: 92px;
			width: 92%;
		}

		.suvinilCoresCelular {
			left: 25%;
			width: 70%;
		}

		.suvinilCoresMetricas {
			grid-template-columns: 1fr;
			gap: 28px;
			margin-top: 100px;
		}

		.suvinilCoresMetrica strong {
			font-size: 82px;
		}

		.suvinilCoresMetrica span {
			font-size: 24px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animCoresDetalhesTexto,
		.animCoresQuadro,
		.animCoresCelular,
		.animCoresMetrica10,
		.animCoresMetrica30,
		.animCoresSeta {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssSuvinilCoresFilmes = styled.div`
	width: 100%;
	background: #fbf2dc;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.suvinilCoresFilmesSection {
		position: relative;
		width: 100%;
		min-height: 1720px;
		background: linear-gradient(to bottom, #68e4ed 0 68%, #fbf2dc 68% 100%);
		overflow: hidden;
		isolation: isolate;
	}

	.suvinilCoresFilmesSection::after {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 570px;
		background: #fbf2dc;
		clip-path: polygon(0 25%, 57% 25%, 73% 0, 100% 0, 100% 100%, 0 100%);
		z-index: 0;
	}

	.suvinilCoresFilmesTopo {
		position: relative;
		width: min(1320px, 100%);
		min-height: 245px;
		margin: 0 auto;
		padding-top: 68px;
		z-index: 4;
	}

	.suvinilCoresFilmesTexto {
		width: min(850px, 70%);
		color: #e40b00;
		font-size: 32px;
		line-height: 1.34;
		font-weight: 400;
	}

	.suvinilCoresFilmesTexto p {
		margin: 0;
	}

	.suvinilCoresFilmesQuadrado {
		position: absolute;
		right: -45px;
    	top: -19px;	
		width: 235px;
		height: 235px;
		object-fit: cover;
		clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
	}

	.suvinilCoresFilmesConteudo {
		position: relative;
		width: min(1440px, 100%);
		 height: 1620px; 
		margin: 0 auto;
		z-index: 2;
		padding-bottom: 5%;
	}

	.suvinilCoresFilmesBlocoAzul {
		position: absolute;
		right: 0;
		bottom: 15%;
		width: 52%;
		height: 390px;
		background: #68e4ed;
		clip-path: polygon(28% 0, 100% 0, 100% 100%, 0 100%);
		z-index: 1;
	}

	.suvinilCoresFilmesImagem {
		position: absolute;
		left: 0;
		top: -40px;
		display: block;
		width: 100%;
		height: auto;
		z-index: 3;
	}

	.suvinilCoresFilmesTriangulo {
		position: absolute;
		left: 0px;
    	top: 220px;
    	width: 170px;
		z-index: 2;
	}

	.suvinilCoresFilmes70 {
		position: absolute;
		left: 72px;
		top: 34px;
		display: flex;
		align-items: center;
		gap: 52px;
		color: #e40b00;
		z-index: 5;
	}

	.suvinilCoresFilmes70 strong {
		display: block;
		font-size: 176px;
		line-height: 0.9;
		font-weight: 900;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	.suvinilCoresFilmes70 div,
	.suvinilCoresFilmes70 p {
		display: block;
		width:320px;
		margin: 0;
		font-size: 38px;
		line-height: 1.04;
		font-weight: 800;
	}

	.suvinilCoresFilmes200 {
		position: absolute;
		left: 295px;
		bottom: 10px;
		color: #e40b00;
		z-index: 5;
	}

	.suvinilCoresFilmes200 strong {
		display: block;
		font-size: 178px;
		line-height: 0.82;
		font-weight: 900;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	.suvinilCoresFilmesSocial {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-top: 18px;
	}

	.suvinilCoresFilmesSocial a {
		display: flex;
		width: 48px;
		height: 48px;
		align-items: center;
		justify-content: center;
		transition: transform 0.25s ease;
	}

	.suvinilCoresFilmesSocial a:hover {
		transform: translateY(-4px);
	}

	.suvinilCoresFilmesSocial img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.suvinilCoresFilmesSocial span {
		display: block;
		margin-left: 6px;
		font-size: 48px;
		line-height: 1;
		font-weight: 900;
		text-transform: uppercase;
	}

	.suvinilCoresNotebook {
		position: absolute;
		right: 0;
		bottom: 18px;
		width: 575px;
		z-index: 4;
	}

	.suvinilCoresFilmesVazado {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 95px;
		z-index: 2;
	}

	.animCoresFilmesTexto,
	.animCoresFilmesQuadrado,
	.animCoresFilmesImagem,
	.animCoresFilmesBlocoAzul,
	.animCoresFilmesTriangulo,
	.animCoresFilmes70,
	.animCoresFilmes200,
	.animCoresNotebook,
	.animCoresFilmesVazado {
		opacity: 0;
		transition-property: opacity, transform;
		transition-duration: 0.8s;
		transition-timing-function: ease;
	}

	.animCoresFilmesTexto {
		transform: translateY(-90px);
	}

	.animCoresFilmesQuadrado {
		transform: translateX(110px);
	}

	.animCoresFilmesImagem {
		transform: translateX(-120px);
		transition-delay: 0.4s;
	}

	.animCoresFilmesBlocoAzul {
		transform: translateX(80px);
		transition-delay: 1.05s;
	}

	.animCoresFilmesTriangulo {
		transform: translateX(-110px);
		transition-delay: 1.25s;
	}

	.animCoresFilmes70 {
		transform: translateX(-100px);
		transition-delay: 1.45s;
	}

	.animCoresFilmes200 {
		transform: translateY(70px);
		transition-delay: 1.75s;
	}

	.animCoresNotebook {
		transform: translateX(-120px);
		transition-delay: 1.75s;
	}

	.animCoresFilmesVazado {
		transform: translateY(120px);
		transition-delay: 1.25s;
	}

	.animateSuvinilCoresFilmes .animCoresFilmesTexto,
	.animateSuvinilCoresFilmes .animCoresFilmesQuadrado,
	.animateSuvinilCoresFilmes .animCoresFilmesImagem,
	.animateSuvinilCoresFilmes .animCoresFilmesBlocoAzul,
	.animateSuvinilCoresFilmes .animCoresFilmesTriangulo,
	.animateSuvinilCoresFilmes .animCoresFilmes70,
	.animateSuvinilCoresFilmes .animCoresFilmes200,
	.animateSuvinilCoresFilmes .animCoresNotebook,
	.animateSuvinilCoresFilmes .animCoresFilmesVazado {
		opacity: 1;
		transform: translate(0, 0);
	}

	@media (max-width: 1366px) {
		.suvinilCoresFilmesSection {
			min-height: 1580px;
		}

		.suvinilCoresFilmesTopo {
			width: min(1180px, 92%);
		}

		.suvinilCoresFilmesTexto {
			font-size: 29px;
		}

		.suvinilCoresFilmesQuadrado {
			width: 205px;
			height: 205px;
		}

		.suvinilCoresFilmesConteudo {
			height: 1560px;
		}
		

		.suvinilCoresFilmesImagem {
			top: -32px;
		}

		.suvinilCoresFilmes70 strong,
		.suvinilCoresFilmes200 strong {
			font-size: 148px;
		}

		.suvinilCoresNotebook {
			width: 660px;
		}
	}

	@media (max-width: 1024px) {
		.suvinilCoresFilmesSection {
			min-height: auto;
			background: linear-gradient(to bottom, #68e4ed 0 58%, #fbf2dc 58% 100%);
		}

		.suvinilCoresFilmesSection::after {
			height: 520px;
			clip-path: polygon(0 20%, 55% 20%, 78% 0, 100% 0, 100% 100%, 0 100%);
		}

		.suvinilCoresFilmesTopo {
			width: 90%;
			min-height: 210px;
			padding-top: 48px;
		}

		.suvinilCoresFilmesTexto {
			width: 70%;
			font-size: 24px;
		}

		.suvinilCoresFilmesQuadrado {
			width: 150px;
			height: 150px;
		}

		.suvinilCoresFilmesConteudo {
			width: 97%;
			height: 1180px;
			padding: 0;
		}

		.suvinilCoresFilmesBlocoAzul {
			right:0%;			
			width: 60%;
			height: 310px;
		}

		.suvinilCoresFilmesImagem {
			left: 0%;
			top: -65px;
			width: 100%;
		}

		.suvinilCoresFilmesTriangulo {
			left: -60px;
			top: 220px;
			width: 170px;
		}

		.suvinilCoresFilmes70 {
			left: 3%;
			top: 10px;
			gap: 24px;
		}

		.suvinilCoresFilmes70 strong {
			font-size: 104px;
		}

		.suvinilCoresFilmes70 div,
		.suvinilCoresFilmes70 p {
			width: 210px;
			font-size: 28px;
		}

		.suvinilCoresFilmes200 {
			left: 9%;
			
		}

		.suvinilCoresFilmes200 strong {
			font-size: 112px;
		}

		.suvinilCoresNotebook {
			right: -5%;
			bottom: 95px;
			width: 430px;
		}
		
	}

	@media (max-width: 820px) {
		.suvinilCoresFilmesSection {
			background: linear-gradient(to bottom, #68e4ed 0 52%, #fbf2dc 52% 100%);
		}

		.suvinilCoresFilmesTopo {
			min-height: 190px;
			padding-top: 36px;
		}

		.suvinilCoresFilmesTexto {
			width: 100%;
			padding-right: 86px;
			font-size: 20px;
		}

		.suvinilCoresFilmesQuadrado {
			right: -24px;
			top: 28px;
			width: 95px;
			height: 95px;
		}

		.suvinilCoresFilmesConteudo {
			width: 92%;
			height: 1040px;
			padding: 0;
		}

		.suvinilCoresFilmesBlocoAzul {
			right: 0%;
			
			width:60%;
			height: 220px;
		}

		.suvinilCoresFilmesImagem {			
			top: 20px;			
		}

		.suvinilCoresFilmesTriangulo {
			left: -90px;
			top: 250px;
			width: 170px;
		}

		.suvinilCoresFilmes70 {
			position: relative;
			grid-column: 1 / -1;
			left: auto;
			top: auto;
			order: -1;
			justify-content: center;
			margin-bottom: 12px;
		}

		.suvinilCoresFilmes70 strong {
			font-size: 94px;
		}

		.suvinilCoresFilmes70 div,
		.suvinilCoresFilmes70 p {
			width: 190px;
			font-size: 25px;
		}

		.suvinilCoresFilmes200 {
                                left: 15%;
        	bottom: 70px;
		}

		.suvinilCoresFilmes200 strong {
			font-size: 86px;
		}

		.suvinilCoresFilmesSocial {
			gap: 8px;
			margin-top: 12px;
		}

		.suvinilCoresFilmesSocial a {
			width: 36px;
			height: 36px;
		}

		.suvinilCoresFilmesSocial span {
			font-size: 32px;
		}

		.suvinilCoresNotebook {
			right: 2%;
			bottom: 95px;
			width: 360px;
		}
		
	}

	@media (max-width: 480px) {

		.suvinilCoresFilmesQuadrado{
		display: none
		}

		.suvinilCoresFilmesTexto {
			padding-right: 0px;
			font-size: 18px;
			 padding-bottom: 20px;
		}

		.suvinilCoresFilmesConteudo {
			height: 900px;
			padding: 0;
		}

		.suvinilCoresFilmesImagem {
			left: -10%;
			top: 55px;
			width: 120%;
		}

		.suvinilCoresFilmesBlocoAzul {
			right: -20%;
			width: 110%;
			height: 220px;
		}

		.suvinilCoresFilmes70 {
			gap: 14px;
		}

		.suvinilCoresFilmes70 strong {
			font-size: 72px;
		}

		.suvinilCoresFilmes70 div,
		.suvinilCoresFilmes70 p {
			width: 150px;
			font-size: 21px;
		}

		.suvinilCoresFilmes200 {
			left: 3%;
			bottom: 205px;
		}

		.suvinilCoresFilmes200 strong {
			font-size: 70px;
		}

		.suvinilCoresFilmesSocial a {
			width: 30px;
			height: 30px;
		}

		.suvinilCoresFilmesSocial span {
			font-size: 27px;
		}

		.suvinilCoresNotebook {
			right: -30%;
			bottom: 92px;
			width: 310px;
		}

	}

	@media (prefers-reduced-motion: reduce) {
		.animCoresFilmesTexto,
		.animCoresFilmesQuadrado,
		.animCoresFilmesImagem,
		.animCoresFilmesBlocoAzul,
		.animCoresFilmesTriangulo,
		.animCoresFilmes70,
		.animCoresFilmes200,
		.animCoresNotebook,
		.animCoresFilmesVazado {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssEdpCase = styled.div`
	width: 100%;
	background: #d52b1e;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

        .edpCaseSection {
                position: relative;
                width: 100%;
                min-height: 930px;
                padding: 34px 0 72px;
                background: #d52b1e;
                overflow: hidden;
                isolation: isolate;
        }

        .edpCaseTitulo {
                position: relative;
                z-index: 3;
                color: #8eefff;
                text-align: center;
                font-size: 35px;
                font-weight: 300;
                line-height: 1;
                letter-spacing: 0;
        }

        .edpCaseCapaWrap {
                position: relative;
                width: min(1640px, 86%);
                margin: 84px auto 0;
                z-index: 2;
        }

        .edpCaseCapa {
                position: relative;
                display: block;
                width: 100%;
                height: auto;
                z-index: 4;
        }

        .edpCaseTrianguloSuperior {
                position: absolute;
                right: -190px;
                top: -66px;
                width: 620px;
                z-index: 1;
                pointer-events: none;
        }

        .edpCaseTrianguloInferior {
                position: absolute;
                left: -74px;
                bottom: -64px;
                width: 520px;
                z-index: 1;
                pointer-events: none;
        }

        .animEdpTitulo,
        .animEdpCapa,
        .animEdpTrianguloSuperior,
        .animEdpTrianguloInferior {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
		transition-timing-function: ease;
	}

	.animEdpTitulo {
		transform: translateY(-90px);
	}

        .animEdpCapa {
                transform: translateY(55px);
                transition-delay: 0.4s;
        }

        .animEdpTrianguloInferior {
                transform: translateX(-130px);
                transition-delay: 0.85s;
        }

        .animEdpTrianguloSuperior {
                transform: translateX(130px);
                transition-delay: 0.85s;
        }

        .animateEdpCase .animEdpTitulo,
        .animateEdpCase .animEdpCapa,
        .animateEdpCase .animEdpTrianguloSuperior,
        .animateEdpCase .animEdpTrianguloInferior {
                opacity: 1;
                transform: translate(0, 0);
        }

        @media (max-width: 1366px) {
                .edpCaseSection {
					min-height: 760px;
					padding-top: 70px;
                }

                .edpCaseTitulo {
                        font-size: 45px;
                }

                .edpCaseCapaWrap {
                        width: 85%;
                        margin-top: 72px;
                }

                .edpCaseTrianguloSuperior {
                        right: -150px;
                        top: -54px;
                        width: 510px;
                }

                .edpCaseTrianguloInferior {
                        left: -62px;
                        bottom: -56px;
                        width: 430px;
                }
        }

        @media (max-width: 1024px) {
                .edpCaseSection {
                        min-height: 650px;
                        padding-bottom: 58px;
                }

                .edpCaseTitulo {
                        font-size: 45px;
                }

                .edpCaseCapaWrap {
                        width: 88%;
                        margin-top: 58px;
                }

                .edpCaseTrianguloSuperior {
                        right: -126px;
                        top: -42px;
                        width: 390px;
                }

                .edpCaseTrianguloInferior {
                        left: -54px;
                        bottom: -48px;
                        width: 330px;
                }
        }

        @media (max-width: 760px) {
                .edpCaseSection {
                        min-height: 520px;
                        padding: 28px 0 50px;
                }

                .edpCaseTitulo {
                        font-size: 45px;
                }

                .edpCaseCapaWrap {
                        width: 92%;
                        margin-top: 44px;
                }

                .edpCaseCapa {
                        width: 132%;
                        margin-left: -16%;
                }

                .edpCaseTrianguloSuperior {
                        right: -118px;
                        top: -30px;
                        width: 290px;
                }

                .edpCaseTrianguloInferior {
                        left: -62px;
                        bottom: -38px;
                        width: 250px;
                }
        }

        @media (max-width: 520px) {
                .edpCaseTitulo {
                        font-size: 30px;
                }
        }

        @media (max-width: 480px) {
                .edpCaseSection {
                        min-height: 360px;
                        padding-top: 24px;
                }

                .edpCaseTitulo {
                        font-size: 30px;
                }

                .edpCaseCapaWrap {
                        width: 94%;
                        margin-top: 34px;
                }

                .edpCaseCapa {
                        width: 100%;
                        margin-left: 0%;
                }

                .edpCaseTrianguloSuperior {
                        right: -108px;
                        top: -24px;
                        width: 230px;
                }

                .edpCaseTrianguloInferior {
                        left: -58px;
                        bottom: -32px;
                        width: 205px;
                }
        }

        @media (prefers-reduced-motion: reduce) {
                .animEdpTitulo,
                .animEdpCapa,
                .animEdpTrianguloSuperior,
                .animEdpTrianguloInferior {
                        opacity: 1;
                        transform: none;
                        transition: none;
		}
	}
`;

export const CssEdpNovoCase = styled.div`
        width: 100%;
        background: #d52b1e;
        font-family: "Barlow", sans-serif;
        overflow: hidden;

        .edpNovoCaseSection {
                position: relative;
                width: 100%;
                min-height: 0;
                padding: 48px 0 0;
                background: #d52b1e;
                overflow: hidden;
                isolation: isolate;
        }

        .edpNovoCaseTitulo {
                position: relative;
                z-index: 3;
                color: #8eefff;
                text-align: center;
                font-size: 35px;
                font-weight: 300;
                line-height: 1;
                letter-spacing: 0;
        }

        .edpNovoCaseVideoWrap {
                position: relative;
                width: 100%;
                margin: 96px auto 0;
                aspect-ratio: 16 / 9;
                z-index: 2;
        }

        .edpNovoCaseVideo {
                position: relative;
                display: block;
                width: 100%;
                height: 100%;
                background: #000;
                z-index: 4;
                overflow: hidden;
        }

        .edpNovoCaseVideo iframe,
        .edpNovoCaseVideoFallback {
                display: block;
                width: 100%;
                height: 100%;
                border: 0;
        }

        .edpNovoCaseVideoFallback {
                object-fit: cover;
        }

        .edpNovoCaseTriangulo {
                position: absolute;
                right: -8px;
                top: -70px;
                width: min(620px, 38vw);
                z-index: 1;
                pointer-events: none;
        }

        .animEdpNovoTitulo,
        .animEdpNovoVideo,
        .animEdpNovoTriangulo {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
                transition-timing-function: ease;
        }

        .animEdpNovoTitulo {
                transform: translateY(-90px);
        }

        .animEdpNovoVideo {
                transform: translateY(55px);
                transition-delay: 0.4s;
        }

        .animEdpNovoTriangulo {
                transform: translateY(90px);
                transition-delay: 1.05s;
        }

        .animateEdpNovoCase .animEdpNovoTitulo,
        .animateEdpNovoCase .animEdpNovoVideo,
        .animateEdpNovoCase .animEdpNovoTriangulo {
                opacity: 1;
                transform: translate(0, 0);
        }

        @media (max-width: 1366px) {
                .edpNovoCaseSection {
                        padding-top: 42px;
                }

                .edpNovoCaseVideoWrap {
                        margin-top: 78px;
                }

                .edpNovoCaseTriangulo {
                        top: -56px;
                        width: min(510px, 38vw);
                }
        }

        @media (max-width: 1024px) {
                .edpNovoCaseSection {
                        padding-top: 34px;
                }

                .edpNovoCaseVideoWrap {
                        margin-top: 58px;
                }

                .edpNovoCaseTriangulo {
                        top: -42px;
                        width: min(390px, 39vw);
                }
        }

        @media (max-width: 760px) {
                .edpNovoCaseSection {
                        padding: 30px 0 0;
                }

                .edpNovoCaseVideoWrap {
                        margin-top: 44px;
                        aspect-ratio: 16 / 10;
                }

                .edpNovoCaseTriangulo {
                        top: -30px;
                        width: min(290px, 46vw);
                }
        }

        @media (max-width: 520px) {
                .edpNovoCaseTitulo {
                        font-size: 30px;
                }
        }

        @media (max-width: 480px) {
                .edpNovoCaseSection {
                        padding-top: 24px;
                }

                .edpNovoCaseVideoWrap {
                        margin-top: 34px;
                        aspect-ratio: 16 / 10;
                }

                .edpNovoCaseTriangulo {
                        right: -10px;
                        top: -22px;
                        width: 220px;
                }
        }

        @media (prefers-reduced-motion: reduce) {
                .animEdpNovoTitulo,
                .animEdpNovoVideo,
                .animEdpNovoTriangulo {
                        opacity: 1;
                        transform: none;
                        transition: none;
                }
        }
`;

export const CssEdpNovoResultados = styled.div`
        width: 100%;
        background: #fbf2dc;
        font-family: "Barlow", sans-serif;
        overflow: hidden;

        .edpNovoResultadosSection {
                position: relative;
                width: 100%;
                min-height: 1600px;
                padding: 78px 0 0;
                background: linear-gradient(to bottom, #68e4ed 0 45%, #fbf2dc 45% 100%);
                overflow: hidden;
                isolation: isolate;
        }

        .edpNovoResultadosHeader {
                position: relative;
                z-index: 5;
                width: min(1180px, 84%);
                margin: 0 auto;
                text-align: center;
                color: #e40b00;
        }

        .edpNovoResultadosTitulo {
                font-size: 45px;
                font-weight: 600;
                line-height: 1.1;
        }

        .edpNovoResultadosTexto {
                width: min(1020px, 100%);
                margin: 54px auto 0;
                font-size: 34px;
                font-weight: 400;
                line-height: 1.35;
        }

        .edpNovoResultadosTitulo p,
        .edpNovoResultadosTexto p {
                margin: 0;
        }

        .edpNovoResultadosTrianguloTop {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
                width: 185px;
                pointer-events: none;
        }

        .edpNovoResultadosVisual {
                position: relative;
                z-index: 4;
                display: grid;
                grid-template-columns: minmax(0, 830px) minmax(320px, 1fr);
                align-items: center;
                gap: 42px;
                width: min(1420px, 94%);
                margin: 60px auto 0;
        }

        .edpNovoResultadosPc {
                position: relative;
                z-index: 4;
                display: block;
                width: 100%;
                max-width: 830px;
                margin-left: -22px;
                filter: drop-shadow(0 24px 38px rgba(0, 0, 0, 0.16));
        }

        .edpNovoResultadosMetricas {
                position: relative;
                z-index: 5;
                display: grid;
                align-self: stretch;
                align-content: start;
                padding-top: 130px;
                padding-bottom: 24px;
        }

        .edpNovoResultadosMetrica {
                color: #e40b00;
                font-weight: 900;
                text-transform: none;
        }

        .edpNovoResultadosMetrica strong {
                display: block;
                font-size: 154px;
                font-weight: 900;
                line-height: 0.82;
                letter-spacing: 0;
        }

        .edpNovoResultadosMetrica span,
        .edpNovoResultadosMetrica small {
                display: block;
                margin-top: 24px;
                font-size: 31px;
                font-weight: 800;
                line-height: 1.05;
        }

        .edpNovoResultadosMetrica small {
                margin-top: 8px;
                font-size: 26px;
        }

        .edpNovoResultadosMetricaPecas {
                position: absolute;
                right: 23%;
                top: 48%;
                z-index: 6;
                width: 520px;
                margin-left: 0;
                text-align: center;
        }

        .edpNovoResultadosTrianguloRight {
                position: absolute;
                right: -10px;
                top: 30%;
                z-index: 2;
                width: 300px;
                pointer-events: none;
        }

        .edpNovoResultadosSeta {
                position: absolute;
                right: 7%;
                top: 49%;
                z-index: 5;
                width: 162px;
                pointer-events: none;
        }

        .edpNovoResultadosCards {
                position: relative;
                z-index: 4;
                display: block;
                width: 112%;
                max-width: none;
                margin: -22px 0 0 -6%;
        }

        .animEdpNovoResultadosTitulo,
        .animEdpNovoResultadosTexto,
        .animEdpNovoResultadosTrianguloTop,
        .animEdpNovoResultadosPc,
        .animEdpNovoResultadosEstados,
        .animEdpNovoResultadosPecas,
        .animEdpNovoResultadosTrianguloRight,
        .animEdpNovoResultadosSeta,
        .animEdpNovoResultadosCards {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
                transition-timing-function: ease;
        }

        .animEdpNovoResultadosTitulo {
                transform: translateY(-90px);
        }

        .animEdpNovoResultadosTexto {
                transform: translateY(90px);
                transition-delay: 0.25s;
        }

        .animEdpNovoResultadosTrianguloTop {
                transform: translateX(-120px);
                transition-delay: 0.55s;
        }

        .animEdpNovoResultadosPc {
                transform: translateY(-120px);
                transition-delay: 0.85s;
        }

        .animEdpNovoResultadosEstados {
                transform: translateX(120px);
                transition-delay: 1.25s;
        }

        .animEdpNovoResultadosPecas {
                transform: translateY(-110px);
                transition-delay: 1.25s;
        }

        .animEdpNovoResultadosTrianguloRight {
                transform: translateX(120px);
                transition-delay: 1.6s;
        }

        .animEdpNovoResultadosSeta {
                transform: translateY(110px);
                transition-delay: 1.85s;
        }

        .animEdpNovoResultadosCards {
                transform: translateY(120px);
                transition-delay: 1.6s;
        }

        .animateEdpNovoResultados .animEdpNovoResultadosTitulo,
        .animateEdpNovoResultados .animEdpNovoResultadosTexto,
        .animateEdpNovoResultados .animEdpNovoResultadosTrianguloTop,
        .animateEdpNovoResultados .animEdpNovoResultadosPc,
        .animateEdpNovoResultados .animEdpNovoResultadosEstados,
        .animateEdpNovoResultados .animEdpNovoResultadosPecas,
        .animateEdpNovoResultados .animEdpNovoResultadosTrianguloRight,
        .animateEdpNovoResultados .animEdpNovoResultadosSeta,
        .animateEdpNovoResultados .animEdpNovoResultadosCards {
                opacity: 1;
                transform: translate(0, 0);
        }

        @media (max-width: 1440px) {
                .edpNovoResultadosSection {
                        min-height: 1320px;
                        padding-top: 64px;
                }

                .edpNovoResultadosTexto {
                        margin-top: 46px;
                        font-size: 30px;
                }

                .edpNovoResultadosVisual {
                        grid-template-columns: minmax(0, 760px) minmax(280px, 1fr);
                        gap: 34px;
                        width: min(1180px, 94%);
                        margin-top: 48px;
                }

                .edpNovoResultadosMetricas {
                        padding-top: 96px;
                }

                .edpNovoResultadosMetrica strong {
                        font-size: 124px;
                }

                .edpNovoResultadosMetricaPecas {
                        right: 15%;
                        width: 440px;
                }

                .edpNovoResultadosMetrica span {
                        font-size: 28px;
                }

                .edpNovoResultadosMetrica small {
                        font-size: 22px;
                }

                .edpNovoResultadosTrianguloRight {
                        width: 240px;
                }

                .edpNovoResultadosSeta {
                        width: 132px;
                }
        }

        @media (max-width: 1024px) {
                .edpNovoResultadosSection {
                        min-height: 1160px;
                        padding-top: 54px;
                        background: linear-gradient(to bottom, #68e4ed 0 40%, #fbf2dc 40% 100%);
                }

                .edpNovoResultadosHeader {
                        width: 88%;
                }

                .edpNovoResultadosTitulo {
                        font-size: 38px;
                }

                .edpNovoResultadosTexto {
                        margin-top: 34px;
                        font-size: 25px;
                }

                .edpNovoResultadosVisual {
                        grid-template-columns: minmax(0, 58%) minmax(220px, 1fr);
                        width: 94%;
                        gap: 20px;
                        margin-top: 42px;
                }

                .edpNovoResultadosPc {
                        width: 100%;
                        max-width: 640px;
                        margin: 0;
                }

                .edpNovoResultadosMetricas {
                        grid-template-columns: 1fr;
                        gap: 0;
                        width: auto;
                        margin: 0;
                        text-align: left;
                        padding-top: 58px;
                        padding-bottom: 0;
                }

                .edpNovoResultadosMetricaPecas {
                        position: absolute;
                        right: 12%;
                        margin-left: 0;
                        width: 340px;
                }

                .edpNovoResultadosMetrica strong {
                        font-size: 88px;
                }

                .edpNovoResultadosMetrica span {
                        margin-top: 16px;
                        font-size: 23px;
                }

                .edpNovoResultadosMetrica small {
                        font-size: 18px;
                }

                .edpNovoResultadosTrianguloTop {
                        width: 95px;
                }

                .edpNovoResultadosTrianguloRight {
                        top:26%;
                        width: 190px;
                }

                .edpNovoResultadosSeta {
                        right: 6%;
                        width: 94px;
                }

                .edpNovoResultadosCards {
                        width: 140%;
                        margin: 20px 0 0 -22%;
                }
        }

        @media (max-width: 720px) {
                .edpNovoResultadosSection {
                        min-height: auto;
                        background: linear-gradient(to bottom, #68e4ed 0 66%, #fbf2dc 66% 100%);
                }

                .edpNovoResultadosVisual {
                        grid-template-columns: 1fr;
                        width: 92%;
                        gap: 26px;
                        margin-top: 40px;
                }

				.edpNovoResultadosTrianguloTop {
					width: 45px;
				}

                .edpNovoResultadosPc {
                        width: min(820px, 108%);
                        max-width: none;
                        margin: 0 auto;
                }

                .edpNovoResultadosMetricas {
                        grid-template-columns: 1fr;
                        gap: 22px;
                        width: 92%;
                        margin: -10px auto 0;
                        text-align: center;
                        padding-top: 0;
                        padding-bottom: 0;
                }

                .edpNovoResultadosMetricaPecas {
                        position: relative;
                        right: auto;
                        top: auto;
                        margin: 0 auto;
                        width: auto;
						margin-top: 20px;
                }

                .edpNovoResultadosTrianguloRight {
                        top: 53%;
                        width: 170px;
                }

                .edpNovoResultadosSeta {
                        right: 8%;
                        top: 61%;
                        width: 96px;
                }

                .edpNovoResultadosCards {
                        width: 152%;
                        margin: 26px 0 0 -26%;
                }
        }

        @media (max-width: 640px) {
                .edpNovoResultadosSection {
                        padding-top: 42px;
                        background: linear-gradient(to bottom, #68e4ed 0 35%, #fbf2dc 35% 100%);
                }

                .edpNovoResultadosTitulo {
                        font-size: 30px;
                }

                .edpNovoResultadosTexto {
                        font-size: 20px;
                        line-height: 1.3;
                }

                .edpNovoResultadosPc {
                        width: 100%;
                        margin-left: 0;
                }

                .edpNovoResultadosMetricas {
                        grid-template-columns: 1fr;
                        gap: 22px;
                        margin-top: 0;
                }

                .edpNovoResultadosMetrica strong {
                        font-size: 76px;
                }

                .edpNovoResultadosMetrica span {
                        margin-top: 12px;
                        font-size: 20px;
                }

                .edpNovoResultadosMetrica small {
                        font-size: 16px;
                }

                .edpNovoResultadosTrianguloRight {
                        right: -50px;
                        top: 51%;
                        width: 140px;
                }

                .edpNovoResultadosSeta {
                        display: none;
                }

                .edpNovoResultadosCards {
                        width: 106%;
                        margin: 10px 0;
                }
        }

        @media (max-width: 420px) {
                .edpNovoResultadosHeader {
                        width: 90%;
                }

                .edpNovoResultadosTexto {
                        font-size: 18px;
                }

                .edpNovoResultadosPc {
                        width: 128%;
                        margin-left: -14%;
                }

                .edpNovoResultadosMetrica strong {
                        font-size: 66px;
                }
        }

        @media (prefers-reduced-motion: reduce) {
                .animEdpNovoResultadosTitulo,
                .animEdpNovoResultadosTexto,
                .animEdpNovoResultadosTrianguloTop,
                .animEdpNovoResultadosPc,
                .animEdpNovoResultadosEstados,
                .animEdpNovoResultadosPecas,
                .animEdpNovoResultadosTrianguloRight,
                .animEdpNovoResultadosSeta,
                .animEdpNovoResultadosCards {
                        opacity: 1;
                        transform: none;
                        transition: none;
                }
        }
`;

export const CssEdpFullResponsa = styled.div`
        width: 100%;
        background: #ef0900;
        font-family: "Barlow", sans-serif;
        overflow: hidden;

        .edpFullResponsaSection {
                position: relative;
                display: grid;
                grid-template-columns: minmax(320px, 34%) minmax(260px, 24%) minmax(360px, 42%);
                grid-template-rows: auto auto;
                gap: 12px;
                width: 100%;
                min-height: 820px;
                padding: 56px 6% 58px;
                background: #ef0900;
                overflow: hidden;
                isolation: isolate;
        }

        .edpFullResponsaTextoBox {
                position: relative;
                z-index: 3;
                grid-column: 1 / 2;
                grid-row: 1 / 2;
                align-self: start;
                padding-top: 10px;
        }

        .edpFullResponsaTextoBox h2 {
                margin: 0;
                color: #fbf2dc;
                font-size: 72px;
                font-weight: 800;
                line-height: 0.95;
                letter-spacing: 0;
        }

        .edpFullResponsaTextoBox h2 p,
        .edpFullResponsaTexto p {
                margin: 0;
        }

        .edpFullResponsaTexto {
                width: min(520px, 100%);
                margin-top: 58px;
                color: #fff;
                font-size: 30px;
                font-weight: 400;
                line-height: 1.34;
                letter-spacing: 0;
        }

        .edpFullResponsaFoto {
                position: relative;
                z-index: 2;
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
        }

        .edpFullResponsaFoto1 {
                grid-column: 2 / 4;
                grid-row: 1 / 2;
                align-self: stretch;
                min-height: 350px;
        }

        .edpFullResponsaFoto2 {
                grid-column: 1 / 3;
                grid-row: 2 / 3;
                justify-self: end;
                width: 92%;
                min-height: 330px;
        }

        .edpFullResponsaMetrica {
                position: relative;
                z-index: 3;
                grid-column: 3 / 4;
                grid-row: 2 / 3;
                align-self: center;
                justify-self: center;
                color: #78e8f0;
                text-align: center;
        }

        .edpFullResponsaMetrica strong {
                display: block;
                color: #78e8f0;
                font-size: 150px;
                font-weight: 800;
                line-height: 0.9;
                letter-spacing: 0;
        }

        .edpFullResponsaMetrica span {
                display: block;
                margin-top: 22px;
                color: #78e8f0;
                font-size: 42px;
                font-weight: 800;
                line-height: 1.05;
                letter-spacing: 0;
        }

        .animEdpFullTitulo,
        .animEdpFullTexto,
        .animEdpFullFoto1,
        .animEdpFullFoto2,
        .animEdpFullMetrica {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
                transition-timing-function: ease;
        }

        .animEdpFullTitulo {
                transform: translateY(-80px);
        }

        .animEdpFullTexto {
                transform: translateY(70px);
                transition-delay: 0.18s;
        }

        .animEdpFullFoto1 {
                transform: translateX(110px);
                transition-delay: 0.55s;
        }

        .animEdpFullFoto2 {
                transform: translateX(-110px);
                transition-delay: 0.82s;
        }

        .animEdpFullMetrica {
                transform: translateY(70px);
                transition-delay: 1.05s;
        }

        .animateEdpFullResponsa .animEdpFullTitulo,
        .animateEdpFullResponsa .animEdpFullTexto,
        .animateEdpFullResponsa .animEdpFullFoto1,
        .animateEdpFullResponsa .animEdpFullFoto2,
        .animateEdpFullResponsa .animEdpFullMetrica {
                opacity: 1;
                transform: translate(0, 0);
        }

        @media (max-width: 1440px) {
                .edpFullResponsaSection {
                        min-height: 710px;
                        padding: 48px 6% 50px;
                        grid-template-columns: minmax(300px, 34%) minmax(230px, 24%) minmax(320px, 42%);
                }

                .edpFullResponsaTextoBox h2 {
                        font-size: 58px;
                }

                .edpFullResponsaTexto {
                        margin-top: 48px;
                        font-size: 25px;
                }

                .edpFullResponsaFoto1 {
                        min-height: 300px;
                }

                .edpFullResponsaFoto2 {
                        min-height: 290px;
                }

                .edpFullResponsaMetrica strong {
                        font-size: 120px;
                }

                .edpFullResponsaMetrica span {
                        font-size: 34px;
                }
        }

        @media (max-width: 1024px) {
                .edpFullResponsaSection {
                        min-height: 610px;
                        padding: 42px 5% 46px;
                        grid-template-columns: minmax(260px, 34%) minmax(210px, 26%) minmax(260px, 40%);
                        gap: 10px;
                }

                .edpFullResponsaTextoBox h2 {
                        font-size: 45px;
                }

                .edpFullResponsaTexto {
                        margin-top: 34px;
                        font-size: 21px;
                }

                .edpFullResponsaFoto1 {
                        min-height: 250px;
                }

                .edpFullResponsaFoto2 {
                        min-height: 240px;
                }

                .edpFullResponsaMetrica strong {
                        font-size: 92px;
                }

                .edpFullResponsaMetrica span {
                        margin-top: 16px;
                        font-size: 26px;
                }
        }

        @media (max-width: 720px) {
                .edpFullResponsaSection {
                        display: flex;
                        flex-direction: column;
                        min-height: auto;
                        padding: 42px 5% 48px;
                        gap: 18px;
                }

                .edpFullResponsaTextoBox {
                        padding-top: 0;
                }

                .edpFullResponsaTextoBox h2 {
                        font-size: 40px;
                }

                .edpFullResponsaTexto {
                        width: 100%;
                        margin-top: 24px;
                        font-size: 20px;
                        line-height: 1.35;
                }

                .edpFullResponsaFoto1,
                .edpFullResponsaFoto2 {
                        width: 100%;
                        min-height: auto;
                        height: auto;
                        object-fit: contain;
                }

                .edpFullResponsaMetrica {
                        width: 100%;
                        padding-top: 12px;
                }

                .edpFullResponsaMetrica strong {
                        font-size: 78px;
                }

                .edpFullResponsaMetrica span {
                        margin-top: 10px;
                        font-size: 22px;
                }
        }

        @media (max-width: 420px) {
                .edpFullResponsaSection {
                        padding: 36px 4% 42px;
                        gap: 16px;
                }

                .edpFullResponsaTextoBox h2 {
                        font-size: 34px;
                }

                .edpFullResponsaTexto {
                        margin-top: 20px;
                        font-size: 18px;
                }

                .edpFullResponsaMetrica strong {
                        font-size: 66px;
                }

                .edpFullResponsaMetrica span {
                        font-size: 19px;
                }
        }

        @media (prefers-reduced-motion: reduce) {
                .animEdpFullTitulo,
                .animEdpFullTexto,
                .animEdpFullFoto1,
                .animEdpFullFoto2,
                .animEdpFullMetrica {
                        opacity: 1;
                        transform: none;
                        transition: none;
                }
        }
`;

export const CssEcomCase = styled.div`
        width: 100%;
        background: #d52b1e;
        font-family: "Barlow", sans-serif;
        overflow: hidden;

        .ecomHeroSection {
                width: 100%;
                padding:30px 24px;
                background: #d52b1e;
                text-align: center;
                overflow: hidden;
        }

        .ecomHeroTitulo {
                margin: 0;
                color: #8eefff;
                font-size: 35px;
                font-weight: 300;
                line-height: 1;
                letter-spacing: 0;
        }

        .ecomHeroTitulo p {
                margin: 0;
        }

        .ecomVideoSection {
                width: 100%;
                background: #000;
                overflow: hidden;
        }

        .ecomVideoWrap {
                width: 100%;
                aspect-ratio: 16 / 9;
                background: #000;
        }

        .ecomVideoWrap iframe {
                display: block;
                width: 100%;
                height: 100%;
                border: 0;
        }

        .ecomCelularSection {
                position: relative;
                width: 100%;
                min-height: 1080px;
                padding: 58px 6% 50px;
                background: #78e8f0;
                overflow: hidden;
                isolation: isolate;
        }

        .ecomCelularTexto {
                position: relative;
                z-index: 4;
                width: min(470px, 40%);
                color: #d52b1e;
                font-size: 20px;
                font-weight:500;
                line-height: 1.14;
                letter-spacing: 0;
        }

        .ecomCelularTexto p {
                margin: 0;
        }

        .ecomTriangulosJuntos {
                position: absolute;
                left: -6%;
                top: 205px;
                z-index: 1;
                width: min(220px, 26vw);
                pointer-events: none;
        }

        .ecomCelularImg {
                position: absolute;
                left:30%;
                top: 42px;
                z-index: 3;
                width: min(760px, 52vw);
                pointer-events: none;
				z-index: 7;
        }

        .ecomCelularSeta {
                position: absolute;
                right: 15%;
                top: 275px;
                z-index: 2;
                width: min(150px, 11vw);
                pointer-events: none;
        }

        .ecomMetrica {
                position: absolute;
                z-index: 4;
                color: #d52b1e;
                font-weight: 800;
                letter-spacing: 0;
        }

        .ecomMetrica strong {
                display: block;
                color: #d52b1e;
                font-size:125px;
                font-weight: 800;
                line-height: 0.85;
                letter-spacing: 0;
                text-transform: uppercase;
        }

        .ecomMetrica span {
                display: block;
                margin-top: 18px;
                color: #d52b1e;
                font-size: 26px;
                font-weight: 800;
                line-height: 1.05;
        }

        .ecomMetrica span p {
                margin: 0;
        }

        .ecomMetrica30 {
                left: 9%;
                bottom: 72px;
        }

        .ecomMetrica70 {
                right: 10%;
                bottom: 84px;
        }

        .ecomPostsSection {
                position: relative;
                width: 100%;
                padding: 34px 5% 54px;
                background: #d52b1e;
                overflow: hidden;
        }

        .ecomPostsGrid,
        .ecomInstasGrid {
                position: relative;
                z-index: 2;
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: 22px;
                width: min(1450px, 100%);
                margin: 0 auto;
        }

        .ecomInstasGrid {
                margin-top: 26px;
        }

        .ecomPostItem,
        .ecomInstaItem {
                display: block;
                width: 100%;
                height: auto;
        }

        .ecomCardImg {
                position: relative;
                z-index: 2;
                display: block;
                width: min(1480px, 98%);
                margin: -5px auto 0;
                height: auto;
        }

        .ecomNotebookSection {
                position: relative;
                width: 100%;
                min-height: 770px;
                padding: 0;
                background: #d52b1e;
                overflow: hidden;
                isolation: isolate;
        }

        .ecomNotebookMetric {
                position: absolute;
                z-index: 4;
                color: #fbf2dc;
                font-weight: 800;
                letter-spacing: 0;
        }

        .ecomNotebookMetric strong {
                display: block;
                color: #fbf2dc;
                font-size: 94px;
                font-weight: 800;
                line-height: 0.9;
                letter-spacing: 0;
                text-transform: uppercase;
        }

        .ecomNotebookMetric span,
        .ecomNotebookMetric p {
                margin: 18px 0 0;
                color: #fbf2dc;
                font-size: 35px;
                font-weight: 500;
                line-height: 1.2;
        }

        .ecomNotebookMetric100 {
                left: 25%;
                top: 90px;
                max-width: 330px;
        }

        .ecomLaptop {
                position: absolute;
                left: 20%;
                top: -5px;
                z-index: 3;
                width: min(1130px, 65vw);
                height: auto;
        }

        .ecomNotebookMetric200 {
                right: 12%;
                bottom: 138px;
                text-align: left;
        }

        .ecomNotebookMetric200 strong {
                font-size: 132px;
        }

        .ecomNotebookTexto {
                position: absolute;
                left: 25%;
                bottom: 25px;
                z-index: 4;
                width: min(450px, 30vw);
                color: #fbf2dc;
                font-size: 16px;
                font-weight: 400;
                line-height: 1.18;
        }

        .ecomNotebookTexto p {
                margin: 0;
        }

        .ecomZBege {
			position: absolute;
			left: 0;
			bottom: 0;
			z-index: 2;
			width: min(280px, 25vw);
			height: auto;
        }

        .ecomNotebookSocial {
			position: absolute;
			right: 9%;
			bottom: 82px;
			z-index: 5;
			display: flex;
			align-items: center;
			gap: 12px;
		}

        .ecomNotebookSocial a,
        .ecomNotebookSocial img {
                display: block;
        }

        .ecomNotebookSocial img {
                width: 30px;
                height: 30px;
                object-fit: contain;
        }

        .ecomNotebookViews {
                display: block;
                color: #fbf2dc;
                font-size: 35px;
                font-weight: 500;
				width: 410px;               
        }

        .ecomFotosSection {
                width: 100%;
                padding: 30px 0;
                background: #d52b1e;
                overflow: hidden;
        }

        .ecomFotosGrid {
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: 10px;
                width: 100%;
        }

        .ecomFotoItem {
                display: block;
                width: 100%;
               /*  aspect-ratio: 1 / 0.72; */
                object-fit: cover;
        }

        .animEcomTitulo,
        .animEcomVideo,
        .animEcomCelularTexto,
        .animEcomTriangulos,
        .animEcomCelularImg,
        .animEcomCelularSeta,
        .animEcomMetrica30,
        .animEcomMetrica70,
        .animEcomPost,
        .animEcomInsta,
        .animEcomCard,
        .animEcomNotebook100,
        .animEcomLaptop,
        .animEcomNotebook200,
        .animEcomNotebookTexto,
        .animEcomZBege,
        .animEcomSocial,
        .animEcomFoto {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
                transition-timing-function: ease;
        }

        .animEcomTitulo,
        .animEcomLaptop,
        .animEcomCard,
        .animEcomCelularImg {
                transform: translateY(-80px);
        }

        .animEcomVideo,
        .animEcomNotebookTexto {
                transform: translateY(70px);
        }

        .animEcomCelularTexto,
        .animEcomTriangulos,
        .animEcomMetrica30,
        .animEcomPost,
        .animEcomZBege,
        .animEcomSocial,
        .animEcomFoto {
                transform: translateX(-90px);
        }

        .animEcomCelularSeta,
        .animEcomMetrica70,
        .animEcomInsta,
        .animEcomNotebook200 {
                transform: translateX(90px);
        }

        .animEcomTriangulos {
                transition-delay: 0.18s;
        }

        .animEcomCelularImg {
                transition-delay: 0.35s;
        }

        .animEcomCelularSeta {
                transition-delay: 0.52s;
        }

        .animEcomMetrica30 {
                transition-delay: 0.68s;
        }

        .animEcomMetrica70 {
                transition-delay: 0.78s;
        }

        .animEcomPost1 { transition-delay: 0s; }
        .animEcomPost2 { transition-delay: 0.12s; }
        .animEcomPost3 { transition-delay: 0.24s; }
        .animEcomPost4 { transition-delay: 0.36s; }
        .animEcomInsta1 { transition-delay: 0.58s; }
        .animEcomInsta2 { transition-delay: 0.7s; }
        .animEcomInsta3 { transition-delay: 0.82s; }
        .animEcomInsta4 { transition-delay: 0.94s; }
        .animEcomCard { transition-delay: 1.15s; }

        .animEcomLaptop { transition-delay: 0.18s; }
        .animEcomNotebook200 { transition-delay: 0.34s; }
        .animEcomNotebookTexto { transition-delay: 0.5s; }
        .animEcomZBege { transition-delay: 0.68s; }
        .animEcomSocial1 { transition-delay: 0.84s; }
        .animEcomSocial2 { transition-delay: 0.94s; }
        .animEcomSocial3 { transition-delay: 1.04s; }
        .animEcomSocial4 { transition-delay: 1.14s; }

        .animEcomFoto1,
        .animEcomFoto5,
        .animEcomFoto9 { transition-delay: 0s; }
        .animEcomFoto2,
        .animEcomFoto6,
        .animEcomFoto10 { transition-delay: 0.12s; }
        .animEcomFoto3,
        .animEcomFoto7,
        .animEcomFoto11 { transition-delay: 0.24s; }
        .animEcomFoto4,
        .animEcomFoto8,
        .animEcomFoto12 { transition-delay: 0.36s; }

        .animateEcomTitulo .animEcomTitulo,
        .animateEcomVideo .animEcomVideo,
        .animateEcomCelular .animEcomCelularTexto,
        .animateEcomCelular .animEcomTriangulos,
        .animateEcomCelular .animEcomCelularImg,
        .animateEcomCelular .animEcomCelularSeta,
        .animateEcomCelular .animEcomMetrica30,
        .animateEcomCelular .animEcomMetrica70,
        .animateEcomPosts .animEcomPost,
        .animateEcomPosts .animEcomInsta,
        .animateEcomPosts .animEcomCard,
        .animateEcomNotebook .animEcomNotebook100,
        .animateEcomNotebook .animEcomLaptop,
        .animateEcomNotebook .animEcomNotebook200,
        .animateEcomNotebook .animEcomNotebookTexto,
        .animateEcomNotebook .animEcomZBege,
        .animateEcomNotebook .animEcomSocial,
        .animateEcomFotos .animEcomFoto {
                opacity: 1;
                transform: translate(0, 0);
        }

        @media (max-width: 1440px) {
                .ecomCelularSection {
                        min-height: 890px;
                        padding-top: 46px;
                }

               
                .ecomCelularImg {
                        width: min(620px, 52vw);
                }

                .ecomMetrica strong {
                        font-size:95px;
                }

                .ecomMetrica span {
                        font-size: 25px;
                }

                .ecomNotebookSection {
                        min-height: 640px;
                }

                .ecomNotebookMetric strong {
                        font-size: 118px;
                }

                .ecomNotebookMetric200 strong {
                        font-size: 128px;
                }

                .ecomNotebookMetric100 {
                        left: 22%;
                        top: 78px;
                }

                .ecomLaptop {
                        left: 19%;
                        top: 0px;
                        width: min(1024px, 65vw);
                }

                .ecomNotebookMetric200 {
                        right: 6%;
                        bottom: 116px;
                }

                .ecomNotebookTexto {
					left:20%;
					bottom: 5px;
					width: min(530px, 40vw);									
                }

                .ecomZBege {
                        width: min(180px, 29vw);
                }

                .ecomNotebookSocial {
					right: 4%;
					bottom: 68px;
                }
               

				.ecomMetrica70 {
					right: 3%;					
				}
        }

        @media (max-width: 1024px) {
                .ecomCelularSection {
                        min-height: 745px;
                        padding: 40px 5% 46px;
                }

                .ecomCelularTexto {
                        width: 34%;
                        font-size: 18px;
                }

                .ecomCelularImg {
                        left: 24%;
                        width: 50vw;
                }

                .ecomTriangulosJuntos {
                        top: 210px;
                        width: 230px;
                }

                .ecomCelularSeta {
                        right: 15%;
                        top: 260px;
                        width: 92px;
                }

                .ecomMetrica strong {
                        font-size: 60px;
                }

				.ecomMetrica span {
					font-size: 20px;
				}

                .ecomMetrica30 {
                        left: 5%;
                        bottom: 58px;
                }

                .ecomMetrica70 {
                        right: 4%;
                        bottom: 64px;
                }

                .ecomPostsGrid,
                .ecomInstasGrid {
                        gap: 14px;
                }

                .ecomNotebookSection {
                        min-height: 520px;
                }

                .ecomLaptop {
                	left: 7%;
					top: -10px;
					width: 76vw;
                }

                .ecomNotebookMetric strong,
                .ecomNotebookMetric200 strong {
                        font-size: 114px;
                }              

                .ecomNotebookMetric100 {
					left: 3%;
					top: 64px;
					max-width: 220px;
                }

				.ecomNotebookMetric span{
					font-size: 25px;
				}

                .ecomNotebookMetric200 {
					right: 5%;
					bottom: 94px;
                }

                .ecomNotebookTexto {
					left: 23%;
					bottom: 15px;                        
                }

                .ecomZBege {
                    width: 130px;
                }

                .ecomNotebookSocial {
                        right: 5%;
                        bottom: 52px;
                        gap: 8px;
                }

                .ecomNotebookSocial img {
                        width: 34px;
                        height: 34px;
                }

                .ecomNotebookViews {
					font-size: 25px;
					width: 245px;
                }
        }

        @media (max-width: 720px) {
                .ecomHeroTitulo {
                        font-size: 30px;
                }

                .ecomCelularSection {
                        display: flex;
                        flex-direction: column;
                        min-height: auto;
                        padding: 36px 5% 42px;
                        gap: 22px;
                }

                .ecomCelularTexto {
                        width: 100%;
                        font-size: 19px;
                }

                .ecomTriangulosJuntos,
                .ecomCelularImg,
                .ecomCelularSeta,
                .ecomMetrica {
                        position: relative;
                        left: auto;
                        right: auto;
                        top: auto;
                        bottom: auto;
                }

                .ecomTriangulosJuntos {
                        width: 150px;
                        order: 2;
                }

                .ecomCelularImg {
                        order: 3;
                        width: min(540px, 100%);
                        align-self: center;
                }

                .ecomCelularSeta {
                        order: 4;
                        width: 88px;
                        align-self: flex-end;
                }

                .ecomMetrica30,
                .ecomMetrica70 {
                        order: 5;
                        text-align: center;
                }

                .ecomMetrica strong {
                        font-size: 68px;
                }

                .ecomMetrica span {
                        margin-top: 10px;
                        font-size: 19px;
                }

                .ecomPostsSection {
                        padding: 28px 4% 40px;
                }

                .ecomPostsGrid,
                .ecomInstasGrid {
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 12px;
                }

                .ecomCardImg {
                        width: 100%;
                        margin-top: 0;
                }

                .ecomNotebookSection {
                        display: flex;
                        flex-direction: column;
                        min-height: auto;
                        padding: 20px;
                        gap: 20px;
                }

				.ecomCelularSeta{
					display: none
				}

                .ecomNotebookMetric,
                .ecomNotebookMetric100,
                .ecomNotebookMetric200,
                .ecomNotebookTexto,
                .ecomZBege,
                .ecomLaptop,
                .ecomNotebookSocial {
					position: relative;
					left: auto;
					right: auto;
					top: auto;
					bottom: auto;
                }

				.ecomZBege, .ecomTriangulosJuntos{
					display: none
				}

                .ecomNotebookMetric,
                .ecomNotebookMetric200,
                .ecomNotebookTexto {
                        width: 100%;
                        text-align: center;
                }

                .ecomNotebookMetric100 {
                        padding-top: 0;
                }

                .ecomLaptop {
                        width: min(620px, 106%);
                }

                .ecomNotebookMetric strong,
                .ecomNotebookMetric200 strong {
                        font-size: 72px;
                }

                .ecomNotebookTexto {
                        font-size: 20px;
                }

                .ecomZBege {
                        width: 170px;
                        align-self: flex-start;
                }

                .ecomNotebookSocial {
					margin-top: 0;
					align-self: center;
					justify-self: center;
					width: 100%;
        			text-align: center;
                }

                .ecomNotebookMetric100{
				        max-width: 100%;
				}

                .ecomFotosGrid {
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 8px;
                }

				.ecomNotebookViews{
					width: 100%;
				}
        }

        @media (max-width: 420px) {

				

                .ecomHeroSection {
                        padding: 16px 12px;
                }

                .ecomHeroTitulo {
                        font-size: 26px;
                }

                .ecomVideoWrap {
                        aspect-ratio: 16 / 10;
                }

                .ecomCelularTexto {
                        font-size: 17px;
                }

                .ecomMetrica strong,
                .ecomNotebookMetric strong,
                .ecomNotebookMetric200 strong {
                        font-size: 58px;
                }

                .ecomPostsGrid,
                .ecomInstasGrid,
                .ecomFotosGrid {
                        grid-template-columns: 1fr;
                }

                .ecomNotebookSocial img {
                        width: 36px;
                        height: 36px;
                }
        }

        @media (prefers-reduced-motion: reduce) {
                .animEcomTitulo,
                .animEcomVideo,
                .animEcomCelularTexto,
                .animEcomTriangulos,
                .animEcomCelularImg,
                .animEcomCelularSeta,
                .animEcomMetrica30,
                .animEcomMetrica70,
                .animEcomPost,
                .animEcomInsta,
                .animEcomCard,
                .animEcomNotebook100,
                .animEcomLaptop,
                .animEcomNotebook200,
                .animEcomNotebookTexto,
                .animEcomZBege,
                .animEcomSocial,
                .animEcomFoto {
                        opacity: 1;
                        transform: none;
                        transition: none;
                }
        }
`;

export const CssEdpSocial = styled.div`
	width: 100%;
	background: #fbf2dc;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

		.edpSocialSection {
				position: relative;
				width: 100%;
				min-height: 1740px;
				padding: 24px 0 20px;
				background: linear-gradient(to bottom, #d52b1e 0 55%, #fbf2dc 55% 100%);
				overflow: hidden;
		isolation: isolate;
	}

	.edpSocialHeader {
		position: relative;
		z-index: 4;
		width: min(1060px, 86%);
		margin: 0 auto;
		text-align: center;
	}

	.edpSocialHeader h2 {
		margin: 0;
		color: #8eefff;
		font-size: 52px;
		font-weight: 800;
		line-height: 1.05;
		letter-spacing: 0;
	}

	.edpSocialSubtitulo {
		width: min(980px, 100%);
		margin: 55px auto 0;
		color: #fff;
		font-size: 20px;
		font-weight: 400;
		line-height: 1.34;
	}

	.edpSocialSubtitulo p,
	.edpSocialMetric p,
	.edpSocialTextoFinal p {
		margin: 0;
	}

	.edpSocialSeta {
		position: absolute;
		left: 18%;
		top: 21%;
		width: 148px;
		z-index: 4;
	}

	.edpSocialVisual {
		position: absolute;
		left: 50%;
		top: 370px;
		width: min(1360px, 92%);
		height: 705px;
		transform: translateX(-50%);
		z-index: 3;
	}

	.edpSocialCard {
		position: absolute;
		display: block;
		width: 430px;
		height: auto;
		z-index: 2;
	}

	.edpSocialCard1 {
		left: 0;
		top: 230px;
	}

	.edpSocialCard2 {
		right: 0;
		top: 390px;
	}

	.edpSocialCelular {
		position: absolute;
		left: 50%;
		top: 0;
		display: block;
		width: 515px;
		height: auto;
		transform: translateX(-50%);
		z-index: 5;
		filter: drop-shadow(0 16px 26px rgba(0, 0, 0, 0.22));
	}

	.edpSocialMetric {
		position: absolute;
		z-index: 5;
		font-weight: 800;
	}

	.edpSocialMetric strong {
		display: block;
		font-size: 100px;
		font-weight: 900;
		line-height: 0.86;
		letter-spacing: 0;
		text-transform: uppercase;
	}

	.edpSocialMetric p {
		margin-top: 44px;
		font-size: 30px;
		font-weight: 500;
		line-height: 1.25;
	}

	.edpSocialMetric100 {
		right: 10%;
		top: 410px;
		width: 360px;
		color: #fbf2dc;
	}

        .edpSocialMetric55 {
                left: 15%;
                bottom: 18%;
                width: 390px;
                color: #e40b00;
        }

	.edpSocialMetric55 strong {
		font-size:70px;
	}

	.edpSocialMetric55 p,
	.edpSocialTextoFinal {
		color: #111;
	}

        .edpSocialTextoFinal {
                position: absolute;
                left: 38%;
                right: 8%;
                bottom: 10%;
                z-index: 5;
                font-size: 30px;
                font-weight: 500;
                line-height: 1.25;
        }

	.animEdpSocialTitulo,
	.animEdpSocialSubtitulo,
	.animEdpSocialSeta,
	.animEdpSocialCelular,
	.animEdpSocialCard1,
	.animEdpSocialCard2,
	.animEdpSocial100,
	.animEdpSocial55,
	.animEdpSocialFinal {
		opacity: 0;
		transition-property: opacity, transform;
		transition-duration: 0.85s;
		transition-timing-function: ease;
	}

	.animEdpSocialTitulo {
		transform: translateY(-90px);
	}

	.animEdpSocialSubtitulo {
		transform: translateY(90px);
	}

	.animEdpSocialSeta {
		transform: translateX(-120px);
		transition-delay: 0.55s;
	}

	.animEdpSocialCelular {
		transform: translate(-50%, -110px);
		transition-delay: 0.85s;
	}

	.animEdpSocialCard1 {
		transform: translateX(-130px);
		transition-delay: 1.25s;
	}

	.animEdpSocialCard2 {
		transform: translateX(130px);
		transition-delay: 1.25s;
	}

	.animEdpSocial100 {
		transform: translateX(-120px);
		transition-delay: 1.65s;
	}

	.animEdpSocial55 {
		transform: translateX(-120px);
		transition-delay: 1.65s;
	}

	.animEdpSocialFinal {
		transform: translateY(90px);
		transition-delay: 2.05s;
	}

	.animateEdpSocial .animEdpSocialTitulo,
	.animateEdpSocial .animEdpSocialSubtitulo,
	.animateEdpSocial .animEdpSocialSeta,
	.animateEdpSocial .animEdpSocialCard1,
	.animateEdpSocial .animEdpSocialCard2,
	.animateEdpSocial .animEdpSocial100,
	.animateEdpSocial .animEdpSocial55,
	.animateEdpSocial .animEdpSocialFinal {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateEdpSocial .animEdpSocialCelular {
		opacity: 1;
		transform: translate(-50%, 0);
	}

	@media (max-width: 1680px) {

		.edpSocialMetric55{
		    left: 11%;
		}

                .edpSocialMetric100 {
                        right: 6%;
                }
	}

		@media (max-width: 1440px) {
			.edpSocialMetric100{
				right: 3%;
			}

			.edpSocialMetric55 {
				left: 5%;
			}
		}

                @media (max-width: 1366px) {
                        .edpSocialSection {
                                padding: 20px;
                        }

			.edpSocialSection {
					min-height: 1460px;
			}

			.edpSocialHeader h2 {
				font-size: 44px;
			}

			.edpSocialSubtitulo {
				margin-top: 48px;
				font-size: 26px;
			}

			.edpSocialSeta {
				top: 27%;
				width: 126px;
			}

			.edpSocialVisual {
				top: 340px;
				height: 620px;
			}

			.edpSocialCard {
				width: 365px;
			}

			.edpSocialCard1 {
                                left: 70px;
			}

			.edpSocialCard2 {
				right: 70px;
			}

			.edpSocialCelular {
				width: 395px;
			}

			.edpSocialMetric100 {
				right: 5%;
				top: 440px;
			}

			.edpSocialMetric55 {
				bottom: 12%;
				left: 10%;
			}

                        .edpSocialMetric strong,
			.edpSocialMetric55 strong {
				font-size: 108px;
			}

			.edpSocialMetric p,
			.edpSocialTextoFinal {
				font-size: 25px;
			}
	}

	@media (max-width: 1024px) {
		.edpSocialSection {
			min-height: auto;
			display: flex;
			flex-direction: column;
			padding: 34px 0 70px;
			background: linear-gradient(to bottom, #d52b1e 0 54%, #fbf2dc 54% 100%);
		}

		.edpSocialHeader {
			order: 1;
			width: 88%;
		}

		.edpSocialHeader h2 {
			font-size: 38px;
		}

		.edpSocialSubtitulo {
			margin-top: 34px;
			font-size: 23px;
		}

		.edpSocialSeta {
			position: relative;
			order: 2;
			left: auto;
			top: auto;
			width: 105px;
			margin: 34px 0 0 12%;
		}

		.edpSocialMetric,
		.edpSocialVisual,
		.edpSocialTextoFinal {
			position: relative;
			left: auto;
			right: auto;
			top: auto;
			bottom: auto;
		}

		.edpSocialMetric100 {
			order: 3;
			width: min(360px, 86%);
			margin: 34px auto 0;
			text-align: center;
		}

		.edpSocialVisual {
			order: 4;
			width: 92%;
			height: 780px;
			margin: 28px auto 0;
			transform: none;
		}

		.edpSocialCard {
			width: 34%;
		}

		.edpSocialCard1 {
			left: 0;
			top: 250px;
		}

		.edpSocialCard2 {
			right: 0;
			top: 380px;
		}

		.edpSocialCelular {
			width: 42%;
		}

		.edpSocialMetric55 {
			order: 5;
			width: min(390px, 86%);
			margin: 34px auto 0;
			text-align: center;
		}

		.edpSocialTextoFinal {
			order: 6;
			width: 86%;
			margin: 32px auto 0;
			text-align: center;
		}

		.edpSocialMetric strong,
		.edpSocialMetric55 strong {
			font-size: 50px;
		}

		.edpSocialMetric p {
			margin-top: 22px;
		}
	}

	@media (max-width: 820px) {
		.edpSocialHeader h2 {
			font-size: 31px;
		}

		.edpSocialSubtitulo {
			font-size: 19px;
		}

		.edpSocialMetric strong,
		.edpSocialMetric55 strong {
			font-size: 35px;
		}

		.edpSocialMetric p,
		.edpSocialTextoFinal {
			font-size: 22px;
		}

		.edpSocialVisual {
			width: 94%;
			height: 630px;
		}

		.edpSocialCard {
			width: 40%;
		}

		.edpSocialCard1 {
			top: 120px;
		}

		.edpSocialCard2 {
			top: 180px;
		}

		.edpSocialCelular {
			width: 40%;
		}
	}

	@media (max-width: 480px) {
		.edpSocialSection {
			background: linear-gradient(to bottom, #d52b1e 0 50%, #fbf2dc 50% 100%);
		}

		.edpSocialHeader h2 {
			font-size: 26px;
		}

		.edpSocialSubtitulo {
			font-size: 17px;
		}

		.edpSocialSeta {
			width: 82px;
			display:none
		}

		.edpSocialMetric strong,
		.edpSocialMetric55 strong {
			font-size: 25px;
		}

		.edpSocialMetric p,
		.edpSocialTextoFinal {
			font-size: 19px;
		}

		.edpSocialVisual {
			height: 320px;
		}

		.edpSocialCard {
			width: 35%;
		}

		.edpSocialCard1 {
			left: 0;
			top: 70px;
		}

		.edpSocialCard2 {
			right: 0;
			top: 110px;
		}

		.edpSocialCelular {
			width: 40%;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.animEdpSocialTitulo,
		.animEdpSocialSubtitulo,
		.animEdpSocialSeta,
		.animEdpSocialCelular,
		.animEdpSocialCard1,
		.animEdpSocialCard2,
		.animEdpSocial100,
		.animEdpSocial55,
		.animEdpSocialFinal {
			opacity: 1;
			transform: none;
			transition: none;
		}
	}
`;

export const CssEdpNotebook = styled.div`
        width: 100%;
        background: #68e4ed;
        font-family: "Barlow", sans-serif;
        overflow: hidden;
		    margin-top: -200px;

        .edpNotebookSection {
                position: relative;
                width: 100%;
                min-height: 1340px;
                padding: 0 0 92px;
                background: linear-gradient(to bottom, #fbf2dc 0 13%, #68e4ed 13% 100%);
                overflow: hidden;
                isolation: isolate;
        }

        .edpNotebookImagem {
                position: relative;
                z-index: 4;
                display: block;
                width: min(1200px, 82%);
                margin: 0 auto;
                padding-top: 22px;
        }

        .edpNotebookTriangulo {
                position: absolute;
                z-index: 2;
                pointer-events: none;
                --edp-triangulo-rotate: 0deg;
        }

        .edpNotebookTrianguloLeft {
                left: 10px;
                top: 180px;
                width: 520px;
        }

        .edpNotebookTriangulosTopRight {
                right: -64px;
                top: -10px;
                width: 270px;
        }

        .edpNotebookConteudo {
                position: relative;
                z-index: 5;
                display: grid;
                grid-template-columns: minmax(0, 1fr) auto;
                column-gap: 54px;
                row-gap: 42px;
                width: min(1180px, 86%);
                margin: 48px auto 0;
                align-items: center;
        }

        .edpNotebookTextoVermelho {
                color: #e40b00;
                font-size: 48px;
                font-weight: 800;
                line-height: 1.12;
        }

        .edpNotebookTextoVermelho p,
        .edpNotebookTextoPreto p {
                margin: 0;
        }

        .edpNotebookSocial {
                display: flex;
                gap: 22px;
                align-items: center;
        }

        .edpNotebookSocial a {
                display: flex;
                width: 76px;
                height: 76px;
                align-items: center;
                justify-content: center;
                transition: transform 0.25s ease;
        }

        .edpNotebookSocial a:hover {
                transform: translateY(-5px);
        }

        .edpNotebookSocial a.edpNotebookZMarca,
        .edpNotebookSocial .animEdpNotebookZest {
                width: 92px;
                height: 76px;
        }

        .edpNotebookSocial img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
        }

        .edpNotebookTextoPreto {
                grid-column: 1 / 2;
                color: #111;
                font-size: 36px;
                font-weight: 400;
                line-height: 1.32;
        }

        .edpNotebookSeta {
                position: absolute;
                right: 11%;
                top: 565px;
                z-index: 5;
                width: 130px;
        }

        .edpNotebookQuadrado {
                position: absolute;
                right: 0;
                bottom: 0;
                z-index: 3;
                width: 300px;
        }

        .animEdpNotebookImagem,
        .animEdpNotebookTriangulo,
        .animEdpNotebookTextoVermelho,
        .animEdpNotebookTextoPreto,
        .animEdpNotebookIcone,
        .animEdpNotebookSeta,
        .animEdpNotebookQuadrado {
                opacity: 0;
                transition-property: opacity, transform;
                transition-duration: 0.85s;
                transition-timing-function: ease;
        }

        .animEdpNotebookImagem {
                transform: translateY(-120px);
        }

        .animEdpNotebookTriangulo {
                transform: translateX(-130px) rotate(var(--edp-triangulo-rotate));
                transition-delay: 0.35s;
        }

        .animEdpNotebookTextoVermelho {
                transform: translateY(-90px);
                transition-delay: 0.85s;
        }

        .animEdpNotebookTextoPreto {
                transform: translateY(90px);
                transition-delay: 0.85s;
        }

        .animEdpNotebookIcone {
                transform: translateX(-42px);
        }

        .animEdpNotebookZest {
                transition-delay: 0.7s;
        }

        .animEdpNotebookInstagram {
                transition-delay: 1.05s;
        }

        .animEdpNotebookYoutube {
                transition-delay: 1.18s;
        }

        .animEdpNotebookSeta {
                transform: translateX(-120px);
                transition-delay: 1.25s;
        }

        .animEdpNotebookQuadrado {
                transform: translateY(90px);
                transition-delay: 1.55s;
        }

        .animateEdpNotebook .animEdpNotebookImagem,
        .animateEdpNotebook .animEdpNotebookTriangulo,
        .animateEdpNotebook .animEdpNotebookTextoVermelho,
        .animateEdpNotebook .animEdpNotebookTextoPreto,
        .animateEdpNotebook .animEdpNotebookIcone,
        .animateEdpNotebook .animEdpNotebookSeta,
        .animateEdpNotebook .animEdpNotebookQuadrado {
                opacity: 1;
                transform: translate(0, 0);
        }

        .animateEdpNotebook .animEdpNotebookTriangulo {
                transform: translate(0, 0) rotate(var(--edp-triangulo-rotate));
        }

        @media (max-width: 1366px) {
                .edpNotebookSection {
                    min-height: 1120px;
                }

                .edpNotebookImagem {
                    width: min(1000px, 82%);
                }

				.edpNotebookTrianguloLeft {
					left: 10px;
					top: 180px;
					width: 429px;
				}

				.edpNotebookTriangulosTopRight {
                    right: 0;
					top: -10px;
					width: 186px;
                }

                .edpNotebookConteudo {
					width: min(1000px, 86%);
					margin-top: 40px;
                }

                .edpNotebookTextoVermelho {
					font-size: 40px;
                }

                .edpNotebookTextoPreto {
                    font-size: 30px;
                }

                .edpNotebookSocial a {
					width: 64px;
					height: 64px;
                }

                .edpNotebookSocial .animEdpNotebookZest {
					width: 64px;
					height: 64px;
                }

                .edpNotebookSeta {
					top: 455px;
					width: 100px;
                }

                .edpNotebookQuadrado {
                    width: 240px;
                }
        }

        @media (max-width: 1024px) {
                .edpNotebookSection {
                        min-height: auto;
                        padding-bottom: 78px;
                }

                .edpNotebookImagem {
                        width: 85%;
                        margin-left: 0%;
                        padding-top: 20px;
                }

                .edpNotebookTrianguloLeft {
                        
                        top: 150px;
                        width: 310px;
                }

                .edpNotebookTriangulosTopRight {
                        right: -78px;
                        top: 0;
                        width: 290px;
                }

                .edpNotebookConteudo {
                        grid-template-columns: 1fr;
                        gap: 28px;
                        width: 86%;
                        margin-top: 34px;
                }

                .edpNotebookTextoVermelho {
                        font-size: 34px;
                }

                .edpNotebookSocial {
                        gap: 16px;
                }

                .edpNotebookTextoPreto {
                        font-size: 26px;
                }

                .edpNotebookSeta {
                        right: 7%;
                        top: 360px;
                        width: 130px;
						display: none
                }

                .edpNotebookQuadrado {
                        width: 120px;
                }
        }

        @media (max-width: 760px) {
                .edpNotebookSection {
                        background: linear-gradient(to bottom, #fbf2dc 0 8%, #68e4ed 8% 100%);
                        padding-bottom: 58px;
                }

                .edpNotebookImagem {
                        width: 125%;
                        margin-left: -14%;
                }

                .edpNotebookTrianguloLeft {
                       
                        top: 112px;
                        width: 230px;
                }

                .edpNotebookTriangulosTopRight,
                .edpNotebookSeta {
                        display: none;
                }

                .edpNotebookConteudo {
                        width: 88%;
                        margin-top: 22px;
                }

                .edpNotebookTextoVermelho {
                        font-size: 28px;
                }

                .edpNotebookSocial {
                        order: 2;
                        gap: 12px;
                }

                .edpNotebookTextoPreto {
                        order: 3;
                        font-size: 21px;
                }

                .edpNotebookSocial a {
                        width: 52px;
                        height: 52px;
                }

                .edpNotebookSocial .animEdpNotebookZest {
                        width: 52px;
                        height: 52px;
                }

                .edpNotebookQuadrado {
                        right: -20px;
                        width: 150px;
                }
        }

        @media (max-width: 480px) {
			.edpNotebookImagem {
				width: 100%;
				margin-left: 0;
			}

			.edpNotebookTextoVermelho {
				font-size: 24px;
			}

			.edpNotebookTextoPreto {
				font-size: 18px;
			}

			.edpNotebookSocial a {
				width: 44px;
				height: 44px;
			}

			.edpNotebookSocial .animEdpNotebookZest {
				width: 44px;
				height: 44px;
			}

			.edpNotebookQuadrado {
				width: 55px;
				right: 0;
			}
        }

        @media (prefers-reduced-motion: reduce) {
                .animEdpNotebookImagem,
                .animEdpNotebookTriangulo,
                .animEdpNotebookTextoVermelho,
                .animEdpNotebookTextoPreto,
                .animEdpNotebookIcone,
                .animEdpNotebookSeta,
                .animEdpNotebookQuadrado {
                        opacity: 1;
                        transform: none;
                        transition: none;
                }
        }
`;
